$(document).ready(function () {
  // кожен блок ініціалізується незалежно: помилка в одному (наприклад,
  // через відсутню секцію на сторінці) не має вбивати решту
  [
    initNavbarScroll,
    initLogosMarquee,
    initProductAccordion,
    initBenefitsVideos,
    initBenefitsMobileVideos,
    initBenefitsCenterCard,
    initBenefitsStripsFill,
    initBenefitsVisuals,
    initTestimonialsSlider,
    initSolutionsSlider,
    initIntegrations,
    initFooterColumns,
    initBurger,
    initFloatingSwitcher,
    initToolsMarquee,
    initNumbersTicker,
    initLinkRoll,
    initTextAnim,
    initAnimatedWords,
    initIntroIllustrations,
    initIntroIconsScatter,
    initIntroIconsLoop,
    initSubscribeForm,
    initPageBlur,
    initCalendlyScale,
    initCalendlyStatus,
    initBlogShare,
    initBlogReadTime,
    initBlogPostNav,
    initLegalPageNav,
    initFaq,
    initArticlesSlider
  ].forEach(function (init) {
    try {
      init();
    } catch (e) {
      console.error(e);
    }
  });
});

// форма підписки у футері: відправка — стандартна вебфлоушна (прихований
// submit), видимі кнопки-лінки лише запускають її. Поверх цього:
//  .form-block__input.is-active — поле заповнене (є хоч один символ)
//  .form-block__input.is-error  — поле не пройшло валідацію (порожнє або
//                                 не e-mail); знімається, щойно користувач
//                                 почав правити значення
//  .form-block__success.is-active — форму відправлено: Webflow після
//                                 успіху показує .w-form-done — ловимо це,
//                                 повертаємо форму на місце вже очищеною і
//                                 на SUCCESS_TIME показуємо свій блок
// Форма в інтро блогу (.blog-page-intro__field) зараз працює так само, як
// футерна: звичайна вебфлоушна відправка і той самий блок успіху (HubSpot
// на неї клієнт підключає сам). Раніше вона нікуди не відправлялась, а після
// валідації вела на хостовану форму ActiveCampaign з e-mail у параметрі.
// Відкат до ActiveCampaign — BLOG_REDIRECT_TO_AC = true, решту не чіпати
function initSubscribeForm() {
  var SUCCESS_TIME = 5000;
  var BLOG_REDIRECT_TO_AC = false;
  var REDIRECT_SCOPE = '.blog-page-intro__field';
  var REDIRECT_URL = 'https://dragin7059.activehosted.com/f/3';
  var forms = Array.prototype.slice.call(document.querySelectorAll('.form-block'));
  if (!forms.length) return;

  forms.forEach(function (block) {
    var form = block.closest('form');
    var input = block.querySelector('.form-block__input');
    var submit = form ? form.querySelector('input[type="submit"]') : null;
    var buttons = Array.prototype.slice.call(block.querySelectorAll('.form-block__button a, .form-block__button button'));
    if (!form || !input || !submit) return;

    function validate() {
      var ok = input.checkValidity() && input.value.trim() !== '';
      input.classList.toggle('is-error', !ok);
      return ok;
    }

    input.addEventListener('input', function () {
      input.classList.toggle('is-active', input.value.trim() !== '');
      // помилку прибираємо одразу, як користувач почав правити;
      // знову перевіримо на наступній спробі відправки
      input.classList.remove('is-error');
    });

    // початковий стан (автозаповнення браузера, повернення по history)
    input.classList.toggle('is-active', input.value.trim() !== '');

    function trySubmit(e) {
      if (e) e.preventDefault();
      if (!validate()) {
        input.focus();
        return;
      }
      // клік по справжньому submit — Webflow перехоплює submit форми і
      // відправляє її сам (ajax, w-form-done / w-form-fail)
      submit.click();
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', trySubmit);
    });

    // Enter у полі: нативний submit теж проходить через нашу валідацію.
    // noValidate вимикає браузерний тултип, щоб помилка показувалась
    // тільки нашим класом
    form.noValidate = true;
    var redirect = BLOG_REDIRECT_TO_AC && !!block.closest(REDIRECT_SCOPE);
    form.addEventListener('submit', function (e) {
      if (!validate()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        input.focus();
        return;
      }
      if (!redirect) return;
      // відправку блокуємо повністю: capture + stopImmediatePropagation —
      // до вебфлоушного обробника (і решти слухачів submit) подія не доходить
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = REDIRECT_URL + '?email=' + encodeURIComponent(input.value.trim());
    }, true);
    if (redirect) return;

    // успіх: Webflow ховає форму і показує .w-form-done (inline display).
    // Спостерігаємо за цим атрибутом — власної події Webflow не дає
    var wrapper = form.closest('.w-form') || form.parentNode;
    var done = wrapper.querySelector('.w-form-done');
    var success = wrapper.querySelector('.form-block__success') ||
      (block.closest('.footer-top__form') || wrapper.parentNode).querySelector('.form-block__success');
    if (!done) return;

    var successTimer = null;

    function onSuccess() {
      // форму повертаємо на місце вже очищеною; стандартний блок
      // вебфлоу лишається схованим — замість нього наш
      form.reset();
      input.classList.remove('is-active', 'is-error');
      form.style.display = '';
      done.style.display = 'none';
      submit.disabled = false;

      if (!success) return;
      clearTimeout(successTimer);
      success.classList.add('is-active');
      successTimer = setTimeout(function () {
        success.classList.remove('is-active');
      }, SUCCESS_TIME);
    }

    var shown = false;
    new MutationObserver(function () {
      var visible = getComputedStyle(done).display !== 'none';
      // реагуємо лише на перехід "схований → показаний"
      if (visible && !shown) onSuccess();
      shown = visible;
    }).observe(done, { attributes: true, attributeFilter: ['style'] });
  });
}

// Calendly показує десктопний лейаут лише коли його iframe ширший за ~1000px,
// тому iframe верстається з фіксованою десктопною шириною (--calendly-width,
// blocks/_deal.sass) і зменшується через transform: scale. Масштаб рахуємо від
// фактичної ширини колонки, а висота обгортки виводиться з нього в CSS через
// calc — тож і масштаб, і висота підлаштовуються під будь-яку ширину екрана.
// На ≤991px змінна знімається: там працює нативна мобільна версія віджета
function initCalendlyScale() {
  var embeds = Array.prototype.slice.call(document.querySelectorAll('.deal__column.is-fw .w-embed'))
    .filter(function (embed) {
      return embed.querySelector('.calendly-inline-widget');
    });
  if (!embeds.length) return;

  var desktop = window.matchMedia('(min-width: 992px)');

  function update() {
    embeds.forEach(function (embed) {
      if (!desktop.matches) {
        embed.style.removeProperty('--calendly-scale');
        return;
      }
      var widgetWidth = parseFloat(getComputedStyle(embed).getPropertyValue('--calendly-width'));
      if (!widgetWidth || !embed.clientWidth) return;
      embed.style.setProperty('--calendly-scale', (embed.clientWidth / widgetWidth).toFixed(4));
    });
  }

  // на мобілці віджет не масштабується, а росте під свій контент: висота
  // кроків різна (вибір дати ~1300px, форма ~1000px, подяка ~650px), і
  // фіксовані 600px давали або порожнечу, або скрол усередині айфрейма.
  // Calendly сам шле фактичну висоту сторінки подією calendly.page_height —
  // беремо її і кладемо в --calendly-mobile-height
  var MIN_HEIGHT = 400; // на старті прилітають службові 2px / 26px — ігноруємо

  function embedFor(source) {
    for (var i = 0; i < embeds.length; i++) {
      var frame = embeds[i].querySelector('iframe');
      if (frame && frame.contentWindow === source) return embeds[i];
    }
    // єдиний віджет на сторінці — інших відправників і бути не може
    return embeds.length === 1 ? embeds[0] : null;
  }

  window.addEventListener('message', function (e) {
    if (e.origin !== 'https://calendly.com') return;
    if (!e.data || e.data.event !== 'calendly.page_height') return;
    var height = parseFloat(e.data.payload && e.data.payload.height);
    if (!height || height < MIN_HEIGHT) return;
    var embed = embedFor(e.source);
    if (embed) embed.style.setProperty('--calendly-mobile-height', Math.round(height) + 'px');
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(update, 100);
  });
  update();

  // висота віджета міняється між кроками (дата → форма → подяка), і
  // користувач опиняється посеред нового кроку або під ним — після зміни
  // висоти підскролюємо до верху календаря з поправкою на навбар.
  // Ловимо зміну висоти самої картки .deal__in: туди входять і ріст
  // айфрейма на мобілці, і transition до блоку подяки. Спрацьовує лише
  // після першої взаємодії користувача зі сторінкою — зміни під час
  // завантаження (перша page_height, lazy-картинки) не смикають скрол;
  // ресайз вікна теж пропускаємо
  if (typeof ResizeObserver !== 'function') return;

  var SCROLL_GAP = 32; // навбар + це повітря над верхом календаря
  var SETTLE = 150; // мс тиші після останньої зміни (transition іде кадрами)
  var armed = false;
  var lastWidth = window.innerWidth;

  // blur — клік усередину айфрейма Calendly: сторінка його не бачить,
  // але фокус вікна іде в айфрейм
  ['pointerdown', 'keydown', 'wheel', 'touchstart', 'blur'].forEach(function (type) {
    window.addEventListener(type, function () {
      armed = true;
    }, { once: true, passive: true });
  });

  embeds.forEach(function (embed) {
    var box = embed.closest('.deal__in') || embed;
    var lastHeight = box.offsetHeight;
    var settleTimer = null;

    new ResizeObserver(function () {
      var height = box.offsetHeight;
      if (height === lastHeight) return;
      lastHeight = height;
      if (window.innerWidth !== lastWidth) {
        lastWidth = window.innerWidth;
        return;
      }
      if (!armed) return;
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        var nav = document.querySelector('.navbar');
        var offset = (nav ? nav.offsetHeight : 0) + SCROLL_GAP;
        window.scrollTo({
          top: embed.getBoundingClientRect().top + window.scrollY - offset,
          behavior: 'smooth'
        });
      }, SETTLE);
    }).observe(box);
  });
}

// статус букінгу в Calendly-айфреймі: віджет шле postMessage-події
// calendly.* на кожен крок — profile_page_viewed, event_type_viewed,
// date_and_time_selected і event_scheduled (успішний букінг). Усі події
// логуються в консоль; після event_scheduled показується блок подяки
// .deal__success (.is-active), а в аналітику летить конверсія
function initCalendlyStatus() {
  if (!document.querySelector('.calendly-inline-widget')) return;

  // блок подяки лежить абсолютно поверх обгортки .deal__in (inset: 0 у
  // вебфлоу-стилях), тож сам по собі її висоти не задає — обгортка
  // фіксує поточну висоту (календаря), а потім плавно переходить до
  // висоти блоку (transition у blocks/_deal.sass) і далі тримає її
  // синхронно: картинки в блоці lazy, та й ресайз ніхто не скасовував
  function showSuccess() {
    var success = document.querySelector('.deal__success');
    if (!success) return;
    var box = success.closest('.deal__in') || success.parentNode;

    box.style.height = box.offsetHeight + 'px';
    box.classList.add('is-done');
    success.classList.add('is-active');
    // примусовий перерахунок стилів, щоб зафіксована висота стала
    // стартовою точкою transition, а не пропустилась разом із новою
    void box.offsetHeight;

    function sync() {
      box.style.height = success.offsetHeight + 'px';
    }
    sync();

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(sync).observe(success);
    } else {
      window.addEventListener('resize', sync);
    }
  }

  // конверсія "демо забукано" в Google Analytics і Facebook Pixel.
  // Скриптів аналітики на сторінці може не бути (дев-оточення) — кожен
  // виклик під охороною; Schedule — стандартний івент піксельної схеми
  // ФБ саме для букінгу зустрічі
  function trackBooking() {
    if (typeof gtag === 'function') {
      gtag('event', 'demo_booked', {
        event_category: 'calendly',
        event_label: 'Dragin Live Demo'
      });
      console.log('[calendly] GA event sent: demo_booked');
    } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({
        event: 'demo_booked',
        event_category: 'calendly',
        event_label: 'Dragin Live Demo'
      });
      console.log('[calendly] dataLayer event sent: demo_booked');
    }

    if (typeof fbq === 'function') {
      fbq('track', 'Schedule', { content_name: 'Dragin Live Demo' });
      console.log('[calendly] FB Pixel event sent: Schedule');
    }
  }

  window.addEventListener('message', function (e) {
    if (e.origin !== 'https://calendly.com') return;
    if (!e.data || typeof e.data.event !== 'string' || e.data.event.indexOf('calendly.') !== 0) return;

    console.log('[calendly]', e.data.event, e.data.payload || '');

    if (e.data.event === 'calendly.event_scheduled') {
      showSuccess();
      trackBooking();
    }
  });
}

// шерінг статті блогу: лінки .blog-post-intro-socials__item у вебфлоу —
// порожні заглушки (href="#"), мережу визначає модифікатор is-linkedin /
// is-x / is-fb. Підставляємо справжній share-URL прямо в href — тож
// працюють і середній клік, і "відкрити в новій вкладці", — а звичайний
// клік відкриває компактне вікно поверх сторінки. Шериться canonical
// (якщо заданий), інакше поточна адреса без хеша
function initBlogShare() {
  var links = Array.prototype.slice.call(document.querySelectorAll('.blog-post-intro-socials__item'));
  if (!links.length) return;

  var canonical = document.querySelector('link[rel="canonical"]');
  var url = (canonical && canonical.href) || window.location.href.split('#')[0];
  var ogTitle = document.querySelector('meta[property="og:title"]');
  var title = (ogTitle && ogTitle.getAttribute('content')) || document.title;

  var u = encodeURIComponent(url);
  var t = encodeURIComponent(title);

  // LinkedIn і Facebook беруть заголовок/картинку з og-тегів сторінки,
  // текст передається лише в X
  var NETWORKS = [
    { cls: 'is-linkedin', label: 'Share on LinkedIn', href: 'https://www.linkedin.com/sharing/share-offsite/?url=' + u },
    { cls: 'is-x', label: 'Share on X', href: 'https://twitter.com/intent/tweet?url=' + u + '&text=' + t },
    { cls: 'is-fb', label: 'Share on Facebook', href: 'https://www.facebook.com/sharer/sharer.php?u=' + u }
  ];

  var POPUP_W = 600;
  var POPUP_H = 640;

  links.forEach(function (link) {
    var network = null;
    for (var i = 0; i < NETWORKS.length; i++) {
      if (link.classList.contains(NETWORKS[i].cls)) {
        network = NETWORKS[i];
        break;
      }
    }
    if (!network) return;

    link.href = network.href;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    // лінк без тексту (іконка фоном) — даємо назву скрінрідерам
    if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', network.label);

    link.addEventListener('click', function (e) {
      // клік із модифікатором — користувач сам вирішив, де відкривати
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var left = Math.max(0, Math.round(window.screenX + (window.outerWidth - POPUP_W) / 2));
      var top = Math.max(0, Math.round(window.screenY + (window.outerHeight - POPUP_H) / 2));
      var popup = window.open(network.href, 'share-' + network.cls,
        'width=' + POPUP_W + ',height=' + POPUP_H + ',left=' + left + ',top=' + top);
      // noopener у features не ставимо: з ним window.open завжди повертає
      // null і заблокований попап не відрізнити від відкритого. Натомість
      // обнуляємо opener вручну; якщо попап заблоковано — спрацьовує
      // звичайний перехід по href у новій вкладці
      if (!popup) return;
      popup.opener = null;
      e.preventDefault();
    });
  });
}

// час читання статті: рахуємо слова в рич-тексті й ділимо на середню
// швидкість читання; у вебфлоу в .blog-post-body-controls__minutes стоїть
// заглушка — перезаписуємо її фактичним значенням. Лейбл може бути
// продубльований у розмітці (окремо для десктопа і для мобілки), тому
// оновлюємо всі, а не лише перший: інакше в одному з них лишалась заглушка
function initBlogReadTime() {
  var WORDS_PER_MINUTE = 200;
  var rich = document.querySelector('.blog-post-body__rich-text');
  var labels = Array.prototype.slice.call(document.querySelectorAll('.blog-post-body-controls__minutes'));
  if (!rich || !labels.length) return;

  var words = (rich.textContent || '').trim().split(/\s+/).filter(Boolean).length;
  var minutes = Math.max(1, Math.ceil(words / WORDS_PER_MINUTE));
  labels.forEach(function (label) {
    label.textContent = minutes + ' min';
  });
}

// зміст (блог і юридичні сторінки): айтеми навігації у вебфлоу —
// заглушки, перший із них беремо за шаблон (розмітка + іконка) і будуємо
// список заново з фактичних заголовків рич-тексту. Клік — плавний скрол до
// заголовка з поправкою на фіксований навбар; при скролі айтем поточного
// розділу отримує .is-active
//  opts.nav, opts.rich — контейнер змісту і рич-текст
//  opts.item           — селектор айтема-шаблона всередині nav
//  opts.link           — селектор елемента з текстом усередині айтема
//                        (необов'язково: без нього текст пишемо в сам айтем)
//  opts.headings       — селектор заголовків рич-тексту
//  opts.activateFirstVisible — чи вважати перший розділ активним, поки
//                        сторінка ще не доскролена до його заголовка, але
//                        заголовок уже у в'юпорті. Юридичні сторінки: зміст
//                        починається одразу з першого розділу, тож він
//                        активний з самого початку; у блозі над першим
//                        заголовком — вступ, там активного немає
function initHeadingsNav(opts) {
  var GAP = 24; // px повітря між навбаром і заголовком після скролу

  var nav = opts.nav;
  var rich = opts.rich;
  if (!nav || !rich) return;

  var template = nav.querySelector(opts.item);
  if (!template) return;

  var headings = Array.prototype.slice.call(rich.querySelectorAll(opts.headings)).filter(function (h) {
    return h.textContent.trim() !== '';
  });

  nav.innerHTML = '';
  if (!headings.length) {
    nav.hidden = true;
    return;
  }

  function getOffset() {
    var navbar = document.querySelector('.navbar');
    return (navbar ? navbar.offsetHeight : 0) + GAP;
  }

  function scrollToHeading(heading, smooth) {
    window.scrollTo({
      top: heading.getBoundingClientRect().top + window.scrollY - getOffset(),
      behavior: smooth ? 'smooth' : 'auto'
    });
  }

  // id для якорів: із тексту заголовка; однакові заголовки отримують
  // суфікс -2, -3…, нелатинський текст (порожній слаг) — section-N
  var used = {};
  function makeId(heading, index) {
    var base = heading.textContent.trim().toLowerCase()
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section-' + (index + 1);
    var id = base;
    var n = 2;
    while (used[id] || document.getElementById(id)) id = base + '-' + n++;
    return id;
  }

  var items = headings.map(function (heading, index) {
    if (!heading.id) heading.id = makeId(heading, index);
    used[heading.id] = true;

    var item = template.cloneNode(true);
    item.classList.remove('is-active');
    var link = (opts.link && item.querySelector(opts.link)) || item;
    link.textContent = heading.textContent.trim();

    // у вебфлоу айтем — div: додаємо йому поведінку лінка для клавіатури
    // та скрінрідерів; якщо ж це справжній <a> — просто ставимо якір
    if (item.tagName === 'A') {
      item.href = '#' + heading.id;
    } else {
      item.setAttribute('role', 'link');
      item.setAttribute('tabindex', '0');
    }
    item.style.cursor = 'pointer';

    function go(e) {
      e.preventDefault();
      scrollToHeading(heading, true);
      history.replaceState(null, '', '#' + heading.id);
    }

    item.addEventListener('click', go);
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') go(e);
    });

    nav.appendChild(item);
    return item;
  });

  // активний — останній заголовок, що вже піднявся до лінії під навбаром
  // (його розділ і є тим, що зараз у в'юпорті). Над першим заголовком
  // активного немає — хіба що activateFirstVisible і заголовок уже видно.
  // Якщо сторінку доскролено до кінця, а останній заголовок до лінії не
  // дістав — активним вважаємо його
  var current = -1;
  function update() {
    var line = getOffset() + 2; // +2 — запас на округлення після скролу по кліку
    var active = -1;
    for (var i = 0; i < headings.length; i++) {
      if (headings[i].getBoundingClientRect().top <= line) active = i;
      else break;
    }
    if (active < 0 && opts.activateFirstVisible && headings[0].getBoundingClientRect().top < window.innerHeight) active = 0;
    var doc = document.documentElement;
    if (window.innerHeight + window.scrollY >= doc.scrollHeight - 2) active = headings.length - 1;

    if (active === current) return;
    current = active;
    items.forEach(function (item, i) {
      item.classList.toggle('is-active', i === active);
    });
    revealActive();
  }

  // довгий зміст не вміщається у в'юпорт і скролиться всередині себе
  // (max-height у _blog-post.sass / _legal-page.sass) — тримаємо активний
  // айтем у видимій частині. Скролимо сам nav, а не scrollIntoView: той
  // смикав би сторінку
  function revealActive() {
    if (current < 0 || nav.scrollHeight <= nav.clientHeight) return;
    var item = items[current];
    // через rect, а не offsetTop: offsetParent айтема залежить від того,
    // чи nav зараз sticky (десктоп), чи статичний
    var top = item.getBoundingClientRect().top - nav.getBoundingClientRect().top + nav.scrollTop;
    var bottom = top + item.offsetHeight;
    if (top < nav.scrollTop) {
      nav.scrollTo({ top: top, behavior: 'smooth' });
    } else if (bottom > nav.scrollTop + nav.clientHeight) {
      nav.scrollTo({ top: bottom - nav.clientHeight, behavior: 'smooth' });
    }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      update();
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  // id з'являються лише після ініціалізації, тож нативний перехід по хешу
  // при завантаженні не спрацьовує — доскролюємо самі
  var hash = decodeURIComponent(window.location.hash.slice(1));
  var target = hash ? document.getElementById(hash) : null;
  if (target && headings.indexOf(target) !== -1) scrollToHeading(target, false);

  update();
}

// зміст статті блогу: розділи — h2/h3 рич-тексту
function initBlogPostNav() {
  initHeadingsNav({
    nav: document.querySelector('.blog-post-body-nav'),
    rich: document.querySelector('.blog-post-body__rich-text'),
    item: '.blog-post-body-nav-item',
    link: '.blog-post-body-nav-item__link',
    headings: 'h2, h3'
  });
}

// зміст юридичних сторінок (terms, privacy, cookie policy): розділи — h3
// рич-тексту. Стани айтемів (сірий / активний чорний / ховер синій) і
// sticky — у _legal-page.sass
function initLegalPageNav() {
  initHeadingsNav({
    nav: document.querySelector('.legal-page-nav'),
    rich: document.querySelector('.legal-page .rich-text'),
    item: '.legal-page-nav__link',
    headings: 'h3',
    activateFirstVisible: true
  });
}

// FAQ-акордеон: розмітка і стилі — з вебфлоу (.faq-item > .faq-item__head +
// .faq-item__body), js лише перемикає .is-open на айтемі; висоту, іконку
// і відступ анімує css (_faq.sass). У межах одного .faq__items відкритий
// лише один айтем: відкриття нового закриває попередній, повторний клік
// по відкритому — закриває його. Стартовий стан — із розмітки: айтем із
// класом is-open у вебфлоу буде розкритий одразу, без нього всі закриті.
// Поява питань при скролі (fade-up по черзі) — режим списку в initTextAnim
function initFaq() {
  var lists = Array.prototype.slice.call(document.querySelectorAll('.faq__items'));
  if (!lists.length) return;

  var counter = 0;
  function makeId() {
    var id;
    do {
      id = 'faq-answer-' + (++counter);
    } while (document.getElementById(id));
    return id;
  }

  lists.forEach(function (list) {
    var items = Array.prototype.slice.call(list.querySelectorAll('.faq-item'));

    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      var head = item.querySelector('.faq-item__head');
      if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    items.forEach(function (item) {
      var head = item.querySelector('.faq-item__head');
      var body = item.querySelector('.faq-item__body');
      if (!head || !body) return;

      // у вебфлоу шапка — div: додаємо їй поведінку кнопки для клавіатури
      // та скрінрідерів
      if (!body.id) body.id = makeId();
      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', '0');
      head.setAttribute('aria-controls', body.id);
      setOpen(item, item.classList.contains('is-open'));

      function toggle() {
        var open = !item.classList.contains('is-open');
        if (open) {
          items.forEach(function (other) {
            if (other !== item) setOpen(other, false);
          });
        }
        setOpen(item, open);
      }

      head.addEventListener('click', toggle);
      head.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault(); // пробіл інакше скролить сторінку
          toggle();
        }
      });
    });
  });
}

// слайдер "Related articles": стрічку веде нативний горизонтальний скрол
// зі снапом (стилі — _articles.sass, клас is-slider), тож свайп на тачі й
// трекпаді працює сам. Стрілки гортають на одну картку; на краях стрічки
// стрілка отримує is-disabled, а якщо всі картки вміщаються — обидві.
// На мобілці стрілки сховані — стрічку гортають свайпом; якщо на
// .articles__items стоїть no-slider — слайдера на мобілці немає, картки
// йдуть стовпчиком (вирішується в css, js тут нічого не перемикає)
function initArticlesSlider() {
  var blocks = Array.prototype.slice.call(document.querySelectorAll('.articles'));
  if (!blocks.length) return;

  blocks.forEach(function (block) {
    var track = block.querySelector('.articles__items');
    if (!track || !track.children.length) return;

    var prevBtn = block.querySelector('.related-articles__controls .is-prev');
    var nextBtn = block.querySelector('.related-articles__controls .is-next');

    track.classList.add('is-slider');

    // крок — відстань між лівими краями сусідніх карток (ширина + гап)
    function getStep() {
      var items = track.children;
      if (items.length > 1) return items[1].offsetLeft - items[0].offsetLeft;
      return items[0].offsetWidth;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prevBtn) prevBtn.classList.toggle('is-disabled', track.scrollLeft <= 1);
      if (nextBtn) nextBtn.classList.toggle('is-disabled', track.scrollLeft >= max - 1);
    }

    function go(dir) {
      var step = getStep();
      if (!step) return;
      // від найближчої картки, а не від сирого scrollLeft: клік посеред
      // інерції свайпу не має накопичувати зсув
      var index = Math.round(track.scrollLeft / step) + dir;
      track.scrollTo({ left: index * step, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      go(-1);
    });
    if (nextBtn) nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      go(1);
    });

    var ticking = false;
    function onChange() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    }

    track.addEventListener('scroll', onChange, { passive: true });
    window.addEventListener('resize', onChange);
    update();
  });
}

// нижній ряд футера (легал-доки) повторює фактичні ширини колонок
// верхнього ряду, щоб лінки стояли рівно під своїми групами
function initFooterColumns() {
  // беремо тільки ряди, в яких реально є колонки з лінками: на сторінці
  // можуть бути інші .footer__column.size-l (наприклад, блок розсилки),
  // і якщо такий стане "еталонним", міряти буде нічого
  var rows = Array.prototype.slice.call(document.querySelectorAll('.footer__column.size-l')).filter(function (row) {
    return row.querySelector('.footer-links');
  });
  if (rows.length < 2) return;

  var topCols = Array.prototype.slice.call(rows[0].querySelectorAll('.footer-links'));
  if (!topCols.length) return;

  // на мобілці ряди складаються в колонку — вирівнювання по ширинах
  // верхнього ряду не потрібне, інлайн-стилі знімаємо
  var footerMobile = window.matchMedia('(max-width: 479px)');

  function sync() {
    rows.slice(1).forEach(function (row) {
      Array.prototype.forEach.call(row.querySelectorAll('.footer-links'), function (col, i) {
        if (footerMobile.matches) {
          col.style.flex = '';
          col.style.width = '';
        } else if (topCols[i]) {
          col.style.flex = 'none';
          col.style.width = topCols[i].offsetWidth + 'px';
        }
      });
    });
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(sync, 100);
  });

  // після довантаження шрифтів ширини колонок міняються — перемірюємо
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(sync);
  }
  sync();
}

// плаваючий перемикач Funders / Brokers (.navbar-fixed): за замовчуванням
// перемикач стоїть у хіро (.intro__nav-tabs); щойно він пішов угору за
// екран, внизу з'являється плаваюча версія і лишається видимою весь час,
// і під час скролу теж (за проханням клієнта; раніше на десктопі вона
// ховалась на час скролу). Зникає лише коли користувач повернувся до
// хіро, щоб перемикач не дублювався. Показ — клас is-visible; схований
// стан за замовчуванням і анімація — у _navbar.sass
function initFloatingSwitcher() {
  var bar = document.querySelector('.navbar-fixed');
  if (!bar) return;

  // перемикач у хіро; якщо його на сторінці нема — орієнтуємось на хіро
  var anchor = document.querySelector('.intro__nav-tabs') ||
    Array.prototype.filter.call(document.querySelectorAll('.nav-tabs'), function (el) {
      return !bar.contains(el);
    })[0] ||
    document.querySelector('.intro-section') ||
    document.querySelector('.intro');

  if (!anchor || !('IntersectionObserver' in window)) {
    bar.classList.add('is-visible');
    return;
  }

  // верх в'юпорта перекриває фіксований навбар: перемикач, що заїхав під
  // нього, теж уже "пішов з екрана"
  var nav = document.querySelector('.navbar');
  var top = nav ? nav.offsetHeight : 0;
  new IntersectionObserver(function (entries) {
    var e = entries[entries.length - 1];
    var away = !e.isIntersecting && e.boundingClientRect.top < top;
    bar.classList.toggle('is-visible', away);
  }, { rootMargin: '-' + top + 'px 0px 0px 0px' }).observe(anchor);
}

// бургер мобільного меню: клік перемикає стани кнопки, меню і скролу
// сторінки; клік поза меню/кнопкою закриває все
function initBurger() {
  $('.btn-burger').on('click', function () {
    $(this).toggleClass('is-active');
    $('html').toggleClass('is-ovh');
    $('body').toggleClass('menu-open');
    $('.mobile-menu').toggleClass('is-active');
  });

  $(document).on('click', function (e) {
    if (!$(e.target).closest('.mobile-menu, .btn-burger').length) {
      $('.btn-burger').removeClass('is-active');
      $('html').removeClass('is-ovh');
      $('body').removeClass('menu-open');
      $('.mobile-menu').removeClass('is-active');
    }
  });
}

// анімація появи текстових блоків (стилі й типи — blocks/_text-anim.sass).
// Два способи активації:
//  1) один атрибут data-anim="head" на контейнері секції — ролі дітей
//     визначаються автоматично: .title → fade-down, заголовок → words
//     (рядки через <br>), .b2/.b1/p → words-blur, кнопки → scale-in;
//  2) точково: data-anim="fade-down|words|words-blur|scale-in" на
//     елементі; data-anim-delay / data-anim-step (сек) перекривають
//     дефолтні таймінги зі спеки.
// JS ховає елементи, ріже текст на слова і стартує все разом, коли
// блок потрапляє у в'юпорт. Тільки десктоп і без prefers-reduced-motion
function initTextAnim() {
  if (!window.matchMedia('(min-width: 480px)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var PRESETS = {
    'fade-down': { delay: .05, step: 0, cls: 'anim-fade-down' },
    'words': { delay: .3, step: .18, cls: 'anim-word', words: true, lines: true },
    'words-blur': { delay: 1.1, step: .03, cls: 'anim-word-blur', words: true },
    'scale-in': { delay: 1.3, step: 0, cls: 'anim-scale-in' }
  };

  // рядок заголовка після <br> стартує на стільки пізніше попереднього
  // (LINE2_START .7s − WORD_BASE_DELAY .3s зі спеки)
  var LINE_STEP = .4;

  // ролі дітей для контейнерного режиму; елемент обробляється лише раз,
  // тож перша роль, що збіглася, виграє
  var HEAD_ROLES = [
    { selector: '.title', type: 'fade-down' },
    { selector: 'h1, h2, h3, .display', type: 'words' },
    { selector: '.b2, .b1, p', type: 'words-blur' },
    { selector: '.w-button, [class*="btn-"]', type: 'scale-in' }
  ];

  // ріже текстові ноди елемента на спани-слова; вкладені теги лишаються
  // на місцях, <br> починає новий рядок
  function splitWords(el) {
    var words = [];
    var line = 0;
    var inLine = 0;
    Array.prototype.slice.call(el.childNodes).forEach(function (node) {
      if (node.nodeName === 'BR') {
        line++;
        inLine = 0;
        return;
      }
      if (node.nodeType !== Node.TEXT_NODE) return;
      var fragment = document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) {
          fragment.appendChild(document.createTextNode(' '));
          return;
        }
        var span = document.createElement('span');
        span.textContent = part;
        fragment.appendChild(span);
        words.push({ span: span, line: line, inLine: inLine++, global: words.length });
      });
      el.replaceChild(fragment, node);
    });
    return words;
  }

  // готує елемент: ховає його (або його слова) і повертає список нод
  // із фінальними затримками
  function prepare(el, type) {
    var preset = PRESETS[type];
    if (!preset || el.hasAttribute('data-anim-ready')) return [];
    el.setAttribute('data-anim-ready', '');

    var delay = parseFloat(el.getAttribute('data-anim-delay'));
    if (isNaN(delay)) delay = preset.delay;
    var step = parseFloat(el.getAttribute('data-anim-step'));
    if (isNaN(step)) step = preset.step;

    var targets;
    if (preset.words) {
      targets = splitWords(el).map(function (w) {
        // заголовок: стаггер у межах рядка, рядки зсунуті на LINE_STEP;
        // сабтекст: суцільний каскад по всіх словах, <br> не рахується
        var d = preset.lines
          ? delay + w.line * LINE_STEP + w.inLine * step
          : delay + w.global * step;
        return { node: w.span, delay: d, cls: preset.cls };
      });
    } else {
      targets = [{ node: el, delay: delay, cls: preset.cls }];
    }
    targets.forEach(function (t) {
      t.node.classList.add('anim-hidden');
    });
    return targets;
  }

  // усі ноди блока стартують разом по в'юпорту, послідовність
  // тримається на animation-delay
  function watch(root, targets) {
    if (!targets.length) return;
    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      targets.forEach(function (t) {
        t.node.style.animationDelay = Math.round(t.delay * 1000) + 'ms';
        t.node.classList.add(t.cls);
        // з cleanup анімаційні класи знімаються по завершенні: анімація
        // з fill-mode both інакше назавжди тримає transform/opacity, і
        // CSS-ховери елемента (напр. scale карток бенефітів) не можуть
        // ні застосуватись, ні плавно транзішнитись. Кінцевий кадр
        // анімацій збігається з природним станом, тож візуально зняття
        // непомітне
        if (t.cleanup) {
          t.node.addEventListener('animationend', function h(e) {
            if (e.target !== t.node) return;
            t.node.removeEventListener('animationend', h);
            t.node.classList.remove(t.cls);
            t.node.classList.remove('anim-hidden');
            t.node.style.animationDelay = '';
          });
        }
      });
      // поріг у частках площі елемента залежить від його висоти: блок,
      // вищий за 1/threshold екранів, ніколи не набирає потрібної частки
      // видимості й анімація не стартує взагалі (на мобілці секції
      // складаються в колонку і легко стають такими). Тому — нульовий
      // поріг плюс відступ знизу: спрацьовує, коли верх блока підіймається
      // на 85% висоти екрана, незалежно від того, який блок заввишки
    }, { threshold: 0, rootMargin: '0px 0px -15% 0px' });
    observer.observe(root);
  }

  // режим списку: діти контейнера по черзі фейдяться знизу вгору.
  // Акцентні (.is-accent) йдуть першими незалежно від місця в DOM,
  // data-anim-skip виключає айтем з анімації, а приховані
  // (напр. mobile-visible на десктопі) не з'їдають чергу.
  // .faq__items — список питань FAQ: режим увімкнено тут за класом, без
  // атрибута у вебфлоу (data-anim-delay / data-anim-step на ньому
  // працюють так само, якщо знадобиться підкрутити таймінги)
  Array.prototype.forEach.call(document.querySelectorAll('[data-anim="items"], .faq__items'), function (container) {
    var delay = parseFloat(container.getAttribute('data-anim-delay'));
    if (isNaN(delay)) delay = .05;
    var step = parseFloat(container.getAttribute('data-anim-step'));
    if (isNaN(step)) step = .15;

    var accents = [];
    var rest = [];
    Array.prototype.forEach.call(container.children, function (item) {
      if (item.hasAttribute('data-anim-skip')) return;
      if (getComputedStyle(item).display === 'none') return;
      (item.classList.contains('is-accent') ? accents : rest).push(item);
    });

    var targets = accents.concat(rest).map(function (item, i) {
      // cleanup: айтеми списків мають власні ховер-ефекти на transform
      return { node: item, delay: delay + i * step, cls: 'anim-fade-up', cleanup: true };
    });
    targets.forEach(function (t) {
      t.node.classList.add('anim-hidden');
    });
    watch(container, targets);
  });

  // контейнерний режим: одна секція — один атрибут
  Array.prototype.forEach.call(document.querySelectorAll('[data-anim="head"]'), function (container) {
    var targets = [];
    HEAD_ROLES.forEach(function (role) {
      Array.prototype.forEach.call(container.querySelectorAll(role.selector), function (el) {
        targets = targets.concat(prepare(el, role.type));
      });
    });
    watch(container, targets);
  });

  // точковий режим
  Array.prototype.forEach.call(document.querySelectorAll('[data-anim]'), function (el) {
    var type = el.getAttribute('data-anim');
    if (type === 'head' || type === 'items') return;
    watch(el, prepare(el, type));
  });
}

// ілюстрації внизу хіро. База (чисте CSS) — фінальний стан: картки
// видимі, нижні плаваючі іконки хіро перенесені в слоти хедерів карток
// (кольорові, поруч назви). Анімація йде "від зворотного": стартовий
// стан відтворюється трансформами (іконки повертаються на свої плаваючі
// позиції, картки сховані), і скраб по скролу зводить усе в нуль — до
// бази. Секція вища за екран, тож фінал саме доскролюється; scrub: 1
// згладжує рух. З reduced motion лишається статична база без анімацій
function initIntroIllustrations() {
  var box = document.querySelector('.intro-illustrations');
  if (!box || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  var inBox = box.querySelector('.intro-illustrations__in');
  var imgs = inBox ? Array.prototype.slice.call(inBox.children) : [];
  if (imgs.length < 3) return;

  var intro = document.querySelector('.intro');
  var hero = box.closest('.intro-section') || intro || box;

  // на мобілці кластер схований (display: none у вебфлоу-стилях), а
  // іконки — статичний кольоровий ряд .intro__icons зі своєю легкою
  // скрол-реакцією (initIntroIconsScatter): ні докінгу, ні польотів
  var mobile = window.matchMedia('(max-width: 479px)');
  if (mobile.matches) return;

  // назви хедерів (порядок = порядок карток у розмітці); коли з'являться
  // поля в Webflow — можна буде читати з data-атрибутів замість констант
  var TITLES = ['Email Automation', 'Document Analysis', 'AI Underwriting'];
  // нижні плаваючі іконки → хедери відповідних карток, і їхні нахили
  // з вебфлоу-стилів — щоб стартовий трансформ точно відтворив вихідне
  var icons = [
    document.querySelector('.intro-icon--3'),
    document.querySelector('.intro-icon--4'),
    document.querySelector('.intro-icon--5')
  ];
  var TILTS = [-16, 15, 15];

  // кольорова версія для докованого стану: .is-docked — гліф без білої
  // плитки (у картці плитка виглядала як "фрейм у фреймі"), якщо такої
  // картинки в розмітці нема — звичайна .is-hover з плиткою
  function coloredOf(icon) {
    return icon.querySelector('.is-docked') || icon.querySelector('.is-hover');
  }

  // поки іконки ще стоять на плаваючих позиціях — запам'ятовуємо центри
  // частками розмірів .intro: після ресайзу маршрут перерахується від
  // актуальної геометрії, а не від застиглих пікселів
  var anchors = icons.map(function (icon) {
    if (!icon || !intro || !icon.offsetWidth) return null;
    var r = icon.getBoundingClientRect();
    var h = intro.getBoundingClientRect();
    if (!h.width || !h.height) return null;
    return {
      fx: (r.left + r.width / 2 - h.left) / h.width,
      fy: (r.top + r.height / 2 - h.top) / h.height,
      size: icon.offsetWidth
    };
  });

  // рідні місця іконок у розмітці (ряд .intro__icons) — щоб повернути
  // їх при переході на мобільний брейкпоінт
  var homes = icons.map(function (icon) {
    return icon ? { parent: icon.parentNode, next: icon.nextSibling } : null;
  });

  // будуємо базу: картка-обгортка (біла, з радіусом і тінню — це окремий
  // шар-бекдроп, щоб його можна було проявляти незалежно від докованої
  // іконки), хедер (слот + назва) і контент-картинка тілом нижче.
  // Сам елемент картки анімація лише рухає трансформом — ніколи не ховає,
  // інакше зникала б і докована іконка
  var titles = [];
  var cards = [];
  var backdrops = [];
  imgs.forEach(function (img, i) {
    // вебфлоушний responsive-скрипт міряє картинку до нашої розкладки і
    // вписує в sizes крихітну ширину — браузер тягне мильну версію;
    // прибираємо srcset/sizes, лишається оригінал із src
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');

    var card = document.createElement('div');
    card.className = 'intro-illustrations__card';
    img.parentNode.insertBefore(card, img);

    var backdrop = document.createElement('div');
    backdrop.className = 'intro-illustrations__card-backdrop';
    card.appendChild(backdrop);
    card.appendChild(img);

    var head = document.createElement('div');
    head.className = 'intro-illustrations__head';
    var slot = document.createElement('span');
    slot.className = 'intro-illustrations__head-slot';
    var title = document.createElement('span');
    title.className = 'intro-illustrations__head-title';
    title.textContent = TITLES[i] || '';
    head.appendChild(slot);
    head.appendChild(title);
    card.appendChild(head);
    if (icons[i]) slot.appendChild(icons[i]);
    titles.push(title);
    cards.push(card);
    backdrops.push(backdrop);
  });

  var tl = null;
  var pin = null;
  // картки вже зібрались і зафіксовані (lockCards) — до перезавантаження
  var locked = false;
  // ховер-контролери докованих іконок (див. нижче), для автоциклу
  var hoverCtl = [];

  // перетин брейкпоінта на мобілку вже після ініту: анімація
  // демонтується, іконки чистяться від трансформів і повертаються на
  // рідні місця в ряд .intro__icons (назад на десктоп без перезавантаження
  // анімація не відбудовується — статична база лишається коректною)
  function teardownToMobile() {
    if (!mobile.matches) return;
    if (tl) {
      if (tl.scrollTrigger) tl.scrollTrigger.kill();
      tl.kill();
      tl = null;
    }
    if (pin) {
      pin.kill();
      pin = null;
    }
    icons.forEach(function (icon, i) {
      if (!icon || !homes[i]) return;
      // у ряду іконка знову звичайна — автоцикл веде її класом
      delete icon._introAutoHover;
      gsap.set(icon, { clearProps: 'all' });
      Array.prototype.forEach.call(icon.querySelectorAll('.intro-icon__icon'), function (img) {
        gsap.set(img, { clearProps: 'opacity,visibility' });
      });
      // сусід, що був за іконкою в ряду, міг і сам переїхати в картку
      // (нижні іконки стоять у ряду підряд) — тоді він уже не дитина
      // ряду, і insertBefore кинув би помилку; ставимо іконку в кінець.
      // Порядок зберігається: іконки повертаються в тому ж порядку,
      // в якому стояли
      var next = homes[i].next;
      if (next && next.parentNode !== homes[i].parent) next = null;
      homes[i].parent.insertBefore(icon, next);
    });
    imgs.forEach(function (img) {
      gsap.set(img, { clearProps: 'all' });
    });
    titles.forEach(function (t) {
      gsap.set(t, { clearProps: 'all' });
    });
    cards.forEach(function (c) {
      gsap.set(c, { clearProps: 'all' });
    });
    backdrops.forEach(function (b) {
      gsap.set(b, { clearProps: 'all' });
    });
  }
  if (mobile.addEventListener) {
    mobile.addEventListener('change', teardownToMobile);
  } else if (mobile.addListener) {
    // старі Safari без addEventListener на MediaQueryList
    mobile.addListener(teardownToMobile);
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // хвіст секції — скільки треба прокрутити до фіналу. Головна вимога:
  // у фіналі верх карток видно. Зазвичай це "низ секції = низ екрана"
  // (секція вища за в'юпорт на кластер карток, і картки вміщаються),
  // але на широкому й невисокому вікні картка вища за простір під
  // навбаром — тоді зупиняємось раніше, коли верх кластера дійшов до
  // навбара; низ карток при цьому ріже екран, а не навпаки
  var nav = document.querySelector('.navbar');
  var TOP_GAP = 24; // px повітря між навбаром і верхом карток

  function tail() {
    var toBottom = hero.offsetHeight - window.innerHeight;
    // box — .intro-illustrations, у фіналі картки стоять без зсуву, тож
    // верх кластера в лейауті і є їхній верх (середня картка в потоці)
    var toTop = layoutRect(box).top - (nav ? nav.offsetHeight : 0) - TOP_GAP;
    return Math.max(0, Math.min(toBottom, toTop));
  }

  // доріжка скрабу: щонайменше ~3/4 екрана скролу, щоб переліт через
  // пів в'юпорта не стискався в кілька обертів колеса і не "скакав"
  function track() {
    return Math.max(window.innerHeight * .75, tail());
  }

  // хвіст на звичайних десктопах коротший за доріжку, і без піна кінець
  // доріжки прокручував сторінку далі, ніж "низ секції = низ екрана" —
  // верх карток ішов під навбар. Тому хіро пінимо рівно на різницю:
  // цю частину скролу пін поглинає (сторінка стоїть, хореографія йде),
  // а останні tail пікселів сторінка їде природно — фінал доріжки
  // збігається з низом секції, логотипи одразу під картками, порожніх
  // смуг у лейауті немає
  pin = ScrollTrigger.create({
    trigger: hero,
    start: 'top top',
    end: function () {
      return '+=' + Math.max(0, track() - tail());
    },
    pin: true,
    anticipatePin: 1,
    invalidateOnRefresh: true
  });

  tl = gsap.timeline({
    defaults: { ease: 'none' },
    scrollTrigger: {
      trigger: hero,
      // межі числами, а не від елемента: тригери після піна ScrollTrigger
      // автоматично зсуває на його спейсер, і старт від хіро опинявся б
      // за кінцем піна — сторінка стояла б без анімації, а політ
      // стискався у хвіст. Хіро — перший блок, тож старт = 0, повна
      // доріжка = пін + природний скрол хвоста
      start: 0,
      end: function () {
        return track();
      },
      scrub: 1.2,
      // якщо користувач зупинив скрол посеред хореографії — доводимо її
      // до кінця (чи назад до початку, якщо рух був угору): скрол сам
      // доїжджає до межі діапазону, застиглих напіврозкритих станів
      // не лишається. Нове колесо/тач одразу скасовує довід
      snap: {
        snapTo: [0, 1],
        duration: { min: .35, max: .9 },
        delay: .08,
        ease: 'power2.inOut'
      },
      invalidateOnRefresh: true,
      // скрол пішов — нижні іконки вже не плавають, автоцикл їх відпускає
      onUpdate: function (self) {
        if (self.progress > 0) releaseAutoHover();
      },
      // скраб доїхав до кінця — картки зібрані, фіксуємо їх. Відкладено
      // на кадр: не вбиваємо ScrollTrigger з його ж колбека
      onScrubComplete: function () {
        requestAnimationFrame(lockCards);
      }
    }
  });

  // картки, що зібрались, лишаються картками до перезавантаження: скрол
  // угору їх уже не розбирає. Скрол-таймлайн зупиняється в кінцевому
  // кадрі (kill(false) у ScrollTrigger не відкочує відрендерене, лише
  // вбиває таймлайн), пін знімається — інакше при скролі вгору хіро стояв
  // би приколотим на всю довжину піна і сторінка "не рухалась" би. Без
  // спейсера піна контент нижче підскакує вгору: зсув міряємо по першому
  // елементу після хіро і компенсуємо скролом — міряємо, а не рахуємо,
  // бо браузерний scroll anchoring міг частину компенсувати сам. Кінцевий
  // кадр — це CSS-база (трансформи в нулі, корпус 100%), тож він коректний
  // і після ресайзу
  function lockCards() {
    if (locked || !tl || tl.progress() < 1) return;
    locked = true;
    releaseAutoHover();

    var spacer = hero.parentNode && hero.parentNode.classList &&
      hero.parentNode.classList.contains('pin-spacer') ? hero.parentNode : hero;
    var ref = spacer.nextElementSibling;
    var before = ref ? ref.getBoundingClientRect().top : 0;

    if (tl.scrollTrigger) tl.scrollTrigger.kill(false);
    tl = null;
    if (pin) {
      pin.kill(true);
      pin = null;
    }

    if (ref) {
      var shift = ref.getBoundingClientRect().top - before;
      if (Math.abs(shift) > .5) {
        window.scrollTo({ top: window.pageYOffset + shift, left: 0, behavior: 'instant' });
      }
    }
    // решта тригерів сторінки рахувала позиції зі спейсером піна
    ScrollTrigger.refresh();
  }

  // центр елемента в координатах сторінки через offset-ланцюжок:
  // на відміну від getBoundingClientRect, не залежить від трансформів.
  // Це критично: refresh ScrollTrigger (наприклад, від довантаження
  // картинок) переобчислює from-функції, коли іконка вже зсунута —
  // rect-виміри давали б нульову дельту і політ "вмирав" у телепорт
  function layoutCenter(el) {
    var x = el.offsetWidth / 2;
    var y = el.offsetHeight / 2;
    while (el) {
      x += el.offsetLeft;
      y += el.offsetTop;
      el = el.offsetParent;
    }
    return { x: x, y: y };
  }

  // те саме для прямокутника: .intro всередині піна зсувається
  // трансформом, тож його rect у польоті вже не дорівнює лейауту
  function layoutRect(el) {
    var c = layoutCenter(el);
    return {
      left: c.x - el.offsetWidth / 2,
      top: c.y - el.offsetHeight / 2,
      width: el.offsetWidth,
      height: el.offsetHeight
    };
  }

  // хореографія за розкадровкою — картка складається на місці:
  //  1) старт — нічого, крім плаваючих іконок;
  //  2) з'являється маленька біла "пігулка" майбутнього хедера, і на
  //     неї сідає іконка, що прилетіла;
  //  3) пігулка розширюється вшир під назву, іконка кольорова, назва
  //     проявляється — картка-хедер із коротким тілом;
  //  4) корпус росте вниз, і в тілі проявляється контент-картинка.
  // Плюс легкий підйом усієї картки для відчуття руху
  function riseOffset() {
    return Math.round(window.innerHeight * .12);
  }

  // іконка докована в картці, тож стартовий зсув картки тягне і її —
  // з дельти положення це віднімається, щоб на старті іконка стояла
  // рівно на своїй плаваючій позиції
  icons.forEach(function (icon, i) {
    var a = anchors[i];
    if (!icon || !a) return;
    var basic = icon.querySelector('.is-basic');
    var hover = coloredOf(icon);
    var docked = hover && hover.classList.contains('is-docked');
    // є версія без плитки — звичайна кольорова (з плиткою) в картці не
    // потрібна взагалі, навіть на ховері
    if (docked) {
      var plain = icon.querySelector('.is-hover');
      if (plain) gsap.set(plain, { autoAlpha: 0 });
    }
    tl.fromTo(icon, {
      x: function () {
        var h = layoutRect(intro);
        return h.left + a.fx * h.width - layoutCenter(icon).x;
      },
      y: function () {
        var h = layoutRect(intro);
        return h.top + a.fy * h.height - layoutCenter(icon).y - riseOffset();
      },
      scale: function () {
        return icon.offsetWidth ? a.size / icon.offsetWidth : 1;
      },
      rotation: TILTS[i]
    }, {
      x: 0,
      y: 0,
      scale: 1,
      rotation: 0, // докована іконка стоїть рівно, в лінію з назвою
      duration: .45,
      // усередині скрабу ізінг формує траєкторію відносно скролу:
      // м'який розгін і м'яка посадка замість лінійного ривка
      ease: 'power2.inOut'
    }, 0);
    // з чорного в кольоровий — по середині польоту
    if (basic) tl.fromTo(basic, { opacity: 1 }, { opacity: 0, duration: .25 }, .22);
    if (hover) tl.fromTo(hover, { opacity: 0 }, { opacity: 1, duration: .25 }, .22);
    // тінь іконки (box-shadow у вебфлоу-стилях) у картці не потрібна —
    // гасимо її в тому ж вікні, що й чорну картинку, у фіналі її нема
    tl.fromTo(icon,
      { boxShadow: '0 4px 15px rgba(0, 0, 0, .1)' },
      { boxShadow: '0 4px 15px rgba(0, 0, 0, 0)', duration: .25 },
      .22);
  });

  // стаггер веде середня картка, бічні наздоганяють — як у розкадровці
  function lag(i) {
    return i === 1 ? 0 : i === 0 ? .04 : .08;
  }

  // легкий підйом картки (сам елемент лише рухається — його не можна
  // ховати, інакше зникла б докована іконка)
  cards.forEach(function (card, i) {
    tl.fromTo(card,
      { y: riseOffset },
      { y: 0, duration: .7, ease: 'power2.out' },
      lag(i));
  });

  // корпус збирається поетапно: пігулка хедера → повна ширина → повна
  // висота. Бекдроп абсолютний з inset: 0, але інлайновий width/height
  // перебиває right/bottom — росте від лівого верхнього кута, як у
  // розкадровці. Стартові розміри функціями від ширини картки —
  // invalidateOnRefresh перераховує їх на ресайзі
  backdrops.forEach(function (backdrop, i) {
    var card = cards[i];
    // радіус нижніх кутів: у пігулки такий самий, як у верхніх, а до
    // фінального нуля (рівний зріз об межу секції) сходить під час
    // доростання висоти
    function pillRadius() {
      return Math.round(card.offsetWidth * .044) + 'px';
    }
    tl.fromTo(backdrop, {
      autoAlpha: 0,
      width: function () { return Math.round(card.offsetWidth * .36) + 'px'; },
      // висота пігулки — симетрично навколо хедера: відступ зверху
      // (offsetTop хедера) дзеркалиться і знизу, у всіх карток однаково
      height: function () {
        var head = card.querySelector('.intro-illustrations__head');
        if (!head) return Math.round(card.offsetWidth * .27) + 'px';
        return Math.round(head.offsetTop * 2 + head.offsetHeight) + 'px';
      },
      borderBottomLeftRadius: pillRadius,
      borderBottomRightRadius: pillRadius
    }, { autoAlpha: 1, duration: .12, ease: 'power1.out' }, .08 + lag(i));
    tl.to(backdrop, { width: '100%', duration: .18, ease: 'power2.inOut' }, .42 + lag(i));
    tl.to(backdrop, {
      height: '100%',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      duration: .22,
      ease: 'power2.inOut'
    }, .6 + lag(i));

      // назва — коли пігулка розширилась і місце під текст уже є
    tl.fromTo(titles[i],
      { autoAlpha: 0 },
      { autoAlpha: 1, duration: .16, ease: 'power1.out' },
      .56 + lag(i));

    // контент розгортається РАЗОМ із ростом корпусу (те саме вікно і
    // ізінг): картка ніколи не стоїть високою і порожньою — саме цей
    // порожній проміжок виглядав як "розтягнута вниз" картка
    tl.fromTo(imgs[i],
      { autoAlpha: 0 },
      { autoAlpha: 1, duration: .06 },
      .6 + lag(i));
    tl.fromTo(imgs[i],
      { clipPath: 'inset(0 0 100% 0)' },
      { clipPath: 'inset(0 0 0% 0)', duration: .22, ease: 'power2.inOut' },
      .6 + lag(i));
  });

  // ховер докованих іконок: CSS тут безсилий (трансформи і опасіті в
  // інлайні від gsap), тож пружний доворот у 0° і кольоровий варіант —
  // тимчасовими твінами поверх скрабу, БЕЗ overwrite (він убив би твіни
  // скрол-таймлайна). На вході знімаємо поточні значення, на виході
  // повертаємо їх — коректно в будь-якій точці скролу; сам скрол,
  // якщо їде одночасно, просто перепише значення своїм рендером.
  // Джерел ховеру два: курсор і автоцикл (initIntroIconsLoop). Стан
  // тримається, поки активне хоч одне, — інакше вихід одного посеред
  // іншого запам'ятав би "ховер" як стан спокою і іконка лишилась би
  // кольоровою
  var canHover = window.matchMedia('(hover: hover)').matches;
  icons.forEach(function (icon, i) {
    if (!icon || !anchors[i]) return;
    var basic = icon.querySelector('.is-basic');
    var hover = coloredOf(icon);
    var rest = null;
    var sources = {};

    function active() {
      for (var k in sources) {
        if (sources[k]) return true;
      }
      return false;
    }

    function enter(src) {
      var was = active();
      sources[src] = true;
      if (was) return;
      rest = {
        rotation: Number(gsap.getProperty(icon, 'rotation')) || 0,
        basic: basic ? Number(gsap.getProperty(basic, 'opacity')) : 1,
        hover: hover ? Number(gsap.getProperty(hover, 'opacity')) : 0
      };
      gsap.to(icon, { rotation: 0, duration: .35, ease: 'back.out(2)' });
      if (basic) gsap.to(basic, { opacity: 0, duration: .2 });
      if (hover) gsap.to(hover, { opacity: 1, duration: .2 });
    }

    function leave(src) {
      if (!sources[src]) return;
      sources[src] = false;
      if (active() || !rest) return;
      gsap.to(icon, { rotation: rest.rotation, duration: .35, ease: 'power2.out' });
      if (basic) gsap.to(basic, { opacity: rest.basic, duration: .25 });
      if (hover) gsap.to(hover, { opacity: rest.hover, duration: .25 });
    }

    hoverCtl.push({ leave: leave });

    if (canHover) {
      icon.addEventListener('mouseenter', function () {
        enter('mouse');
      });
      icon.addEventListener('mouseleave', function () {
        leave('mouse');
      });
    }

    // автоцикл бере іконку, лише поки вона плаває: до старту збирання
    // карток (прогрес скролу 0) і не після фіксації
    icon._introAutoHover = {
      eligible: function () {
        return !locked && !!tl && tl.progress() === 0;
      },
      enter: function () {
        enter('auto');
      },
      leave: function () {
        leave('auto');
      }
    };
  });

  function releaseAutoHover() {
    hoverCtl.forEach(function (ctl) {
      ctl.leave('auto');
    });
  }
}

// мобільний хіро: п'ять іконок стоять статичним кольоровим рядом
// (.intro__icons), але реагують на скрол — кожна відпливає у свій бік
// (напрям продовжує її нахил у композиції, тому рух природний, а не
// симетричний) і поступово розчиняється; скрол угору грає все назад.
// Прив'язано скрабом до прогресу скролу — плавно, без разових тригерів
// і різких рухів. Десктоп живе іншою анімацією (initIntroIllustrations)
function initIntroIconsScatter() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var mobile = window.matchMedia('(max-width: 479px)');
  if (!mobile.matches) return;

  // працює на будь-якій сторінці з рядом .intro__icons — на відміну від
  // десктопного польоту, який прив'язаний до блоку ілюстрацій
  var row = document.querySelector('.intro__icons');
  if (!row || !row.children.length) return;
  var hero = document.querySelector('.intro-section') || row;
  gsap.registerPlugin(ScrollTrigger);

  // вектори розльоту за нахилами мобільної розкладки (-12/+12/-12/...):
  // нахилена вліво іконка пливе вліво-вниз і докручується проти
  // годинникової, нахилена вправо — дзеркально; центральна йде вниз
  var DRIFT = [
    { x: -34, y: 40, r: -8 },
    { x: -14, y: 56, r: 6 },
    { x: 0, y: 34, r: -6 },
    { x: 14, y: 56, r: 6 },
    { x: 34, y: 40, r: -8 }
  ];

  var tl = gsap.timeline({
    defaults: { ease: 'power1.inOut' },
    scrollTrigger: {
      trigger: hero,
      start: 'top top',
      end: '+=60%',
      scrub: 1,
      invalidateOnRefresh: true
    }
  });
  Array.prototype.forEach.call(row.children, function (icon, i) {
    var d = DRIFT[i % DRIFT.length];
    // '+=' докручує від нахилу, заданого в CSS
    tl.to(icon, { x: d.x, y: d.y, rotation: '+=' + d.r, autoAlpha: 0, duration: 1 }, 0);
  });

  // перетин брейкпоінта на десктоп: розліт демонтується, трансформи
  // чистяться — далі іконками керує десктопна логіка (з перезавантаження)
  function teardownToDesktop() {
    if (mobile.matches) return;
    if (tl.scrollTrigger) tl.scrollTrigger.kill();
    tl.kill();
    Array.prototype.forEach.call(row.children, function (icon) {
      gsap.set(icon, { clearProps: 'all' });
    });
  }
  if (mobile.addEventListener) {
    mobile.addEventListener('change', teardownToDesktop);
  } else if (mobile.addListener) {
    // старі Safari без addEventListener на MediaQueryList
    mobile.addListener(teardownToDesktop);
  }
}

// автоцикл ховера плаваючих іконок хіро: іконки по черзі на мить входять
// у свій ховер-стан (вирівнюються в 0° і стають кольоровими) і
// повертаються — тихий цикл, з якого видно, що іконки інтерактивні, навіть
// якщо курсор до них так і не дійшов. Працює на будь-якій сторінці з рядом
// .intro__icons і не зупиняється на скролі (на Brokers іконки просто
// стоять на місці). На головній нижні іконки, поки плавають, керуються
// таймлайном карток: вхід/вихід у ховер для них дає initIntroIllustrations
// (icon._introAutoHover), а коли картки почали збиратись, вони з циклу
// випадають. Поза екраном цикл стоїть. Тільки десктоп (на мобілці іконки й
// так кольорові) і без reduced motion
function initIntroIconsLoop() {
  var STEP = 1400; // мс між стартами сусідніх іконок
  var HOLD = 1000; // мс, скільки іконка тримає ховер-стан
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var desktop = window.matchMedia('(min-width: 480px)');

  var icons = Array.prototype.slice.call(document.querySelectorAll('.intro-icon'));
  if (!icons.length) return;

  // порядок — за номером у класі (intro-icon--N): доковані іконки
  // initIntroIllustrations переносить у картки, тож порядок у DOM уже інший
  function num(el) {
    var m = el.className.match(/intro-icon--(\d+)/);
    return m ? Number(m[1]) : 0;
  }
  icons.sort(function (a, b) {
    return num(a) - num(b);
  });

  var hero = document.querySelector('.intro-section') || document.querySelector('.intro') || icons[0];
  var inView = true;
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      inView = entries[entries.length - 1].isIntersecting;
    }).observe(hero);
  }

  function eligible(icon) {
    if (icon._introAutoHover) return icon._introAutoHover.eligible();
    // звичайна плаваюча іконка: у ряду хіро і показана
    return !!icon.closest('.intro__icons') && icon.getClientRects().length > 0;
  }

  function enter(icon) {
    if (icon._introAutoHover) icon._introAutoHover.enter();
    else icon.classList.add('is-auto-hover');
  }

  function leave(icon) {
    if (icon._introAutoHover) icon._introAutoHover.leave();
    else icon.classList.remove('is-auto-hover');
  }

  var index = -1;
  setInterval(function () {
    if (!desktop.matches || document.hidden || !inView) return;
    for (var k = 1; k <= icons.length; k++) {
      var j = (index + k) % icons.length;
      if (!eligible(icons[j])) continue;
      index = j;
      var icon = icons[j];
      enter(icon);
      setTimeout(function () {
        leave(icon);
      }, HOLD);
      return;
    }
  }, STEP);
}

// ротатор слів у заголовку хіро (перенесено зі старого сайту): спан з
// data-animated-text-to="a, b, c" перетворюється на стопку слів в одній
// грід-комірці (.gw-wrapper тримає ширину найширшого — рядок не
// сіпається), слова по колу проявляються вайпом clip-path зліва направо
// і так само зникають; колір — суцільний, від колірного класу спана в
// розмітці. Стилі — blocks/_text-anim.sass. З reduced motion лишається
// статичний текст із розмітки
function initAnimatedWords() {
  var wrappers = document.querySelectorAll('[data-animated-text-to]');
  if (!wrappers.length || typeof gsap === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var HOLD = 1.2;    // сек, слово стоїть повністю видиме
  var WIPE_IN = 1;   // сек, проявлення
  var WIPE_OUT = .5; // сек, зникнення

  Array.prototype.forEach.call(wrappers, function (wrapper) {
    var raw = wrapper.getAttribute('data-animated-text-to') || '';
    var list = raw.split(',').map(function (s) {
      return s.trim();
    }).filter(Boolean);
    if (list.length < 2) return;

    wrapper.innerHTML = '';
    wrapper.removeAttribute('data-animated-text-to');
    wrapper.classList.add('gw-wrapper');

    var nodes = list.map(function (text) {
      var word = document.createElement('span');
      word.className = 'gw-word';
      word.textContent = text;
      wrapper.appendChild(word);
      return word;
    });

    // ширина обгортки і вайп слова йдуть строго в ногу: однакові
    // тривалість та ізінг, тож видимий край тексту завжди прилягає до
    // сусіднього слова — без діри між недорозкритим словом і "workflow".
    // Значення ширини функцією: repeatRefresh перечитує його на кожному
    // колі, тож після довантаження шрифтів ширина сама виправляється
    function wordWidth(i) {
      return function () {
        return nodes[i].offsetWidth + 'px';
      };
    }

    // до старту таймлайна обгортка стиснута, інакше один кадр висіла б
    // на ширині найширшого слова зі стопки
    gsap.set(wrapper, { width: 0 });

    var tl = gsap.timeline({
      repeat: -1,
      repeatRefresh: true,
      defaults: { ease: 'power3.inOut' }
    });
    nodes.forEach(function (word, i) {
      var label = 'w' + i;
      tl.addLabel(label)
        // проявлення: слово відкривається зліва направо, ширина росте
        // від нуля тим самим ізінгом — край у край
        .fromTo(word,
          { clipPath: 'inset(0 100% 0 0)' },
          { clipPath: 'inset(0 0% 0 0)', duration: WIPE_IN },
          label)
        .fromTo(wrapper,
          { width: 0 },
          { width: wordWidth(i), duration: WIPE_IN },
          label)
        .to(word, { duration: HOLD })
        // зникнення — відкат: край ховається справа наліво синхронно
        // зі стисканням обгортки до нуля, "workflow" плавно під'їжджає
        .to(word, { clipPath: 'inset(0 100% 0 0)', duration: WIPE_OUT })
        .to(wrapper, { width: 0, duration: WIPE_OUT }, '<');
    });

    // зміна брейкпоінта міняє кегль заголовка, шрифти можуть доїхати
    // після ініту — обидва випадки перечитують ширини слів
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        tl.invalidate();
      });
    }
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        tl.invalidate();
      }, 150);
    });
  });
}

// смуга прогресивного блуру внизу в'юпорта: контейнер із п'ятьма
// шарами, кожен зі своїм радіусом і маскою (стилі — blocks/_block.sass).
// Коли у в'юпорт заходить футер — смуга плавно ховається, щоб не
// розмивати його вміст; при скролі вгору повертається
function initPageBlur() {
  var box = document.createElement('div');
  box.className = 'page-blur';
  for (var i = 0; i < 5; i++) {
    box.appendChild(document.createElement('span'));
  }
  document.body.appendChild(box);

  var footer = document.querySelector('.footer');
  if (!footer) return;
  function update() {
    var top = footer.getBoundingClientRect().top;
    box.classList.toggle('is-hidden', top < window.innerHeight - 40);
  }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
}

// ховер-ефект текстових лінок навбара (rolling-текст лише там, футер
// живе простим згасанням кольору в CSS): текст ріжеться на літери, які
// по черзі прокручуються вгору (стилі — blocks/_link-roll.sass); клік
// прокручує текст назад — літери повертаються на місце тим самим
// стаггером. Тільки пристрої з курсором: на тачі ховера немає, тож і
// різати текст на спани нема сенсу
function initLinkRoll() {
  if (!window.matchMedia('(hover: hover)').matches) return;

  var STAGGER = 16; // мс затримки на літеру

  var links = document.querySelectorAll('.navbar__link');

  Array.prototype.forEach.call(links, function (link) {
    // у навбарі текст лежить у .button-nav, у футері — прямо в лінку
    var textEl = link.querySelector('.button-nav') || link;
    // лінки зі складнішим вмістом (іконки, вкладені блоки) не чіпаємо
    if (textEl.children.length) return;
    var text = textEl.textContent.trim();
    if (!text) return;

    var roll = document.createElement('span');
    roll.className = 'link-roll';
    // текст розсипано на спани — даємо скрінрідерам цілісну назву
    roll.setAttribute('aria-hidden', 'true');
    link.setAttribute('aria-label', text);

    var letterIndex = 0;
    text.split(' ').forEach(function (word, wi) {
      if (wi) roll.appendChild(document.createTextNode(' '));
      var wordEl = document.createElement('span');
      wordEl.className = 'link-roll__word';
      word.split('').forEach(function (ch) {
        var letter = document.createElement('span');
        letter.className = 'link-roll__letter';
        var char = document.createElement('span');
        char.className = 'link-roll__char';
        char.setAttribute('data-char', ch);
        char.textContent = ch;
        char.style.transitionDelay = letterIndex * STAGGER + 'ms';
        letter.appendChild(char);
        wordEl.appendChild(letter);
        letterIndex++;
      });
      roll.appendChild(wordEl);
    });

    textEl.textContent = '';
    textEl.appendChild(roll);
    link.classList.add('link-roll-host');

    // клік: літери прокручуються назад (is-pressed глушить ховер-зсув);
    // клас знімається, коли курсор пішов — наступний ховер знову крутить
    link.addEventListener('click', function () {
      link.classList.add('is-pressed');
    });
    link.addEventListener('mouseleave', function () {
      link.classList.remove('is-pressed');
    });
  });
}

// цифри в секції numbers докручуються від нуля до значення, коли секція
// вперше з'являється у в'юпорті; суфікс ("x", "%") лишається як є
// цифри-одометр: кожен розряд — колонка зі стрічкою 0–9, яка прокручується
// по вертикалі й плавно гальмує на своєму значенні. Молодші розряди крутяться
// довше і зупиняються останніми, суфікс (x, %) проявляється наприкінці.
// Анімація лише на transform/opacity — жодних перемальовок тексту
function initNumbersTicker() {
  var container = document.querySelector('.numbers__items');
  if (!container || typeof gsap === 'undefined') return;

  var items = Array.prototype.slice.call(container.querySelectorAll('.numbers-item'));
  var values = Array.prototype.slice.call(container.querySelectorAll('.numbers-item .h1'));
  if (!values.length) return;

  var DURATION = 2.6;   // сек, прокрутка одного розряду
  var STAGGER = .16;    // сек, зсув між айтемами
  var DIGIT_LAG = .12;  // сек, наскільки пізніше зупиняється кожен молодший розряд
  var SPINS = 2;        // повних обертів стрічки перед фінальною цифрою
  var EASE = 'expo.out';

  var targets = values.map(function (el) {
    var m = el.textContent.trim().match(/^(\d+)(.*)$/);
    if (!m) return null;

    // висота рядка — крок стрічки; фіксуємо її і ширину по фінальному
    // значенню, щоб сусідній текст не сіпався
    var lineH = el.getBoundingClientRect().height;
    el.style.display = 'inline-block';
    el.style.minWidth = el.offsetWidth + 'px';
    el.style.height = lineH + 'px';
    el.style.fontVariantNumeric = 'tabular-nums';
    el.classList.add('odometer');

    el.textContent = '';
    var digits = m[1].split('').map(function (ch) {
      var col = document.createElement('span');
      col.className = 'odometer__digit';
      col.style.height = lineH + 'px';
      var strip = document.createElement('span');
      strip.className = 'odometer__strip';
      // SPINS повних кіл + фінальна цифра: стрічка 0..9 повторюється
      var count = SPINS * 10 + Number(ch) + 1;
      for (var i = 0; i < count; i++) {
        var d = document.createElement('span');
        d.className = 'odometer__num';
        d.style.height = lineH + 'px';
        d.textContent = i % 10;
        strip.appendChild(d);
      }
      col.appendChild(strip);
      el.appendChild(col);
      return { strip: strip, offset: -(count - 1) * lineH };
    });

    var suffix = null;
    if (m[2]) {
      suffix = document.createElement('span');
      suffix.className = 'odometer__suffix';
      suffix.textContent = m[2];
      el.appendChild(suffix);
    }

    return { el: el, digits: digits, suffix: suffix };
  }).filter(Boolean);
  if (!targets.length) return;

  function run() {
    var tl = gsap.timeline();

    tl.to(items, {
      opacity: 1,
      y: 0,
      duration: 1.2,
      ease: 'power3.out',
      stagger: STAGGER
    }, 0);

    targets.forEach(function (t, i) {
      var at = i * STAGGER;
      t.digits.forEach(function (d, j) {
        tl.fromTo(d.strip, { y: 0, filter: 'blur(0px)' }, {
          y: d.offset,
          duration: DURATION + j * DIGIT_LAG,
          ease: EASE
        }, at);
        // легкий motion blur на піку швидкості, зникає до зупинки
        tl.to(d.strip, { filter: 'blur(6px)', duration: .25, ease: 'power1.in' }, at)
          .to(d.strip, { filter: 'blur(0px)', duration: 1.2, ease: 'power2.out' }, at + .35);
      });
      if (t.suffix) {
        tl.fromTo(t.suffix, { opacity: 0, y: 10 }, {
          opacity: 1,
          y: 0,
          duration: .8,
          ease: 'power3.out'
        }, at + DURATION * .45);
      }
    });
  }

  // поріг по площі не годиться: висока секція (на мобілці — колонка)
  // ніколи не набере 40% видимості і цифри назавжди лишаться прихованими
  var observer = new IntersectionObserver(function (entries) {
    if (!entries[0].isIntersecting) return;
    observer.disconnect();
    run();
  }, { threshold: 0, rootMargin: '0px 0px -15% 0px' });

  gsap.set(items, { opacity: 0, y: 24 });
  targets.forEach(function (t) {
    if (t.suffix) gsap.set(t.suffix, { opacity: 0 });
  });
  observer.observe(container);
}

function initNavbarScroll() {
  var navbar = document.querySelector('.navbar');
  if (!navbar) return;

  var THRESHOLD = 30; // px скролу, після яких навбар отримує is-active

  // секції з data-section-color: поки навбар перекриває будь-яку з них,
  // він отримує суцільний білий фон (is-solid, стилі — _navbar.sass);
  // вище/нижче такої секції фон знімається
  var colored = Array.prototype.slice.call(document.querySelectorAll('[data-section-color]'));

  function update() {
    navbar.classList.toggle('is-active', window.scrollY > THRESHOLD);
    if (!colored.length) return;
    var navH = navbar.offsetHeight || 0;
    var solid = false;
    for (var i = 0; i < colored.length; i++) {
      var r = colored[i].getBoundingClientRect();
      if (r.top < navH && r.bottom > 0) {
        solid = true;
        break;
      }
    }
    navbar.classList.toggle('is-solid', solid);
  }

  window.addEventListener('scroll', update, { passive: true });
  update();
}

// кастомний слайдер рішень: трек — flex-стрічка, позицію веде gsap,
// морф ширин карток і поява опису — CSS-транзішни по класу is-active.
// керування: стрілки, клік по згорнутій картці, драг з інерційним доснапом
function initSolutionsSlider() {
  var track = document.querySelector('.solutions__items');
  if (!track || typeof gsap === 'undefined') return;

  var items = Array.prototype.slice.call(track.querySelectorAll('.solutions-item'));
  if (items.length < 2) return;

  var viewport = track.closest('.solutions__body') || track.parentNode;
  var prevBtn = document.querySelector('.solutions__controls .is-prev');
  var nextBtn = document.querySelector('.solutions__controls .is-next');

  var n = items.length;
  var active = 0;

  var solutionsMobile = window.matchMedia('(max-width: 479px)');

  // розміри беруться з CSS-змінних треку (_solutions.sass) — одне
  // джерело правди, щоб кламп і крок завжди збігались із розкладкою
  function cssLength(style, name) {
    var v = style.getPropertyValue(name).trim();
    var num = parseFloat(v) || 0;
    if (/rem$/.test(v)) return num * parseFloat(getComputedStyle(document.documentElement).fontSize);
    if (/em$/.test(v)) return num * parseFloat(style.fontSize);
    return num; // px
  }

  function metrics() {
    var ts = getComputedStyle(track);
    var narrow = cssLength(ts, '--sol-narrow');
    var activeW = cssLength(ts, '--sol-active');
    var gap = cssLength(ts, '--sol-gap');
    var step = narrow + gap;
    var total = (n - 1) * step + activeW; // повна стрічка з активною
    // кламп по контентній ширині вьюпорта (без падінгів на всю ширину
    // екрана) — останній айтем зупиняється на правому краю контейнера
    var cs = getComputedStyle(viewport);
    var contentW = viewport.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    return {
      step: step,
      minX: Math.min(0, contentW - total)
    };
  }

  function setActive(i) {
    active = i;
    items.forEach(function (item, idx) {
      item.classList.toggle('is-active', idx === i);
    });
    if (prevBtn) prevBtn.classList.toggle('is-disabled', i === 0);
    if (nextBtn) nextBtn.classList.toggle('is-disabled', i === n - 1);
  }

  function goTo(i, immediate) {
    i = Math.max(0, Math.min(n - 1, i));
    setActive(i);
    var m = metrics();
    // на мобілці стрічку веде нативний скрол зі снапом (як у benefits)
    if (solutionsMobile.matches) {
      viewport.scrollTo({
        left: i * m.step,
        behavior: immediate ? 'auto' : 'smooth'
      });
      return;
    }
    var x = Math.max(m.minX, -i * m.step);
    gsap[immediate ? 'set' : 'to'](track, {
      x: x,
      duration: .65,
      ease: 'power2.inOut',
      overwrite: 'auto'
    });
  }

  // на мобілці користувач гортає і руками — поточний індекс беремо
  // з фактичної позиції скролу
  function currentIndex() {
    if (solutionsMobile.matches) {
      return Math.round(viewport.scrollLeft / metrics().step);
    }
    return active;
  }

  if (prevBtn) prevBtn.addEventListener('click', function (e) {
    e.preventDefault();
    goTo(currentIndex() - 1);
  });
  if (nextBtn) nextBtn.addEventListener('click', function (e) {
    e.preventDefault();
    goTo(currentIndex() + 1);
  });

  // синхронізація стану стрілок з ручним скролом на мобілці
  var scrollRaf = null;
  viewport.addEventListener('scroll', function () {
    if (!solutionsMobile.matches || scrollRaf) return;
    scrollRaf = requestAnimationFrame(function () {
      scrollRaf = null;
      setActive(Math.max(0, Math.min(n - 1, Math.round(viewport.scrollLeft / metrics().step))));
    });
  }, { passive: true });

  // драг стрічки: тягнемо трек за курсором з гумовими краями,
  // на відпусканні снапимось до найближчої позиції з урахуванням швидкості
  var dragging = false;
  var dragMoved = false;
  var startX = 0;
  var startTrackX = 0;
  var lastX = 0;
  var lastT = 0;
  var velocity = 0; // px/ms, знак — напрям руху курсора

  viewport.addEventListener('pointerdown', function (e) {
    if (solutionsMobile.matches) return; // на мобілці драг нативний
    dragging = true;
    dragMoved = false;
    startX = lastX = e.clientX;
    lastT = e.timeStamp;
    velocity = 0;
    startTrackX = Number(gsap.getProperty(track, 'x'));
    gsap.killTweensOf(track);
  });

  window.addEventListener('pointermove', function (e) {
    if (!dragging) return;
    var dx = e.clientX - startX;
    if (Math.abs(dx) > 5) dragMoved = true;
    var m = metrics();
    var x = startTrackX + dx;
    // за краями стрічка йде на третині швидкості — "гума"
    if (x > 0) x *= .3;
    if (x < m.minX) x = m.minX + (x - m.minX) * .3;
    gsap.set(track, { x: x });
    var dt = e.timeStamp - lastT;
    if (dt > 0) velocity = (e.clientX - lastX) / dt;
    lastX = e.clientX;
    lastT = e.timeStamp;
  });

  window.addEventListener('pointerup', function () {
    if (!dragging) return;
    dragging = false;
    if (!dragMoved) return;
    var m = metrics();
    var x = Number(gsap.getProperty(track, 'x'));
    var target = Math.round(-x / m.step);
    // швидкий свайп докидає щонайменше на одну позицію в бік руху
    if (velocity < -.5) target = Math.max(target, active + 1);
    if (velocity > .5) target = Math.min(target, active - 1);
    goTo(target);
    // click прилітає після pointerup — гасимо його тактом пізніше
    setTimeout(function () {
      dragMoved = false;
    }, 0);
  });

  // клік по згорнутій картці робить її активною (лише десктоп —
  // на мобілці картки рівнозначні і гортаються скролом)
  items.forEach(function (item, i) {
    item.addEventListener('click', function () {
      if (solutionsMobile.matches || dragMoved || i === active) return;
      goTo(i);
    });
  });

  // нативний drag картинок ламає pointer-события
  track.addEventListener('dragstart', function (e) {
    e.preventDefault();
  });

  var resizeTimer;
  // опису картки заздалегідь фіксується ФІНАЛЬНА піксельна ширина
  // (внутрішня ширина розгорнутої картки): з чистим width: 100% рядки
  // перевпорядковувались би на кожному кадрі морфу ширини — текст
  // "скакав". З фіксацією він одразу зверстаний під кінцеву ширину,
  // а в спокої це ті самі 100%. На мобілці морфу немає — інлайн
  // знімається, працює width: auto зі стилів
  function lockDescWidth() {
    var mobileNow = solutionsMobile.matches;
    var activeW = cssLength(getComputedStyle(track), '--sol-active');
    items.forEach(function (item) {
      var b3 = item.querySelector('.solutions-item__text .b3');
      if (!b3) return;
      if (mobileNow || !activeW) {
        b3.style.width = '';
        return;
      }
      var text = item.querySelector('.solutions-item__text');
      var pad = 0;
      if (text) {
        var cs = getComputedStyle(text);
        pad = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
      }
      b3.style.width = Math.round(activeW - pad) + 'px';
    });
  }

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      // при переході на мобілку прибираємо gsap-transform треку,
      // щоб нативний скрол починав з чистої позиції
      if (solutionsMobile.matches) gsap.set(track, { clearProps: 'transform' });
      lockDescWidth();
      goTo(active, true);
    }, 100);
  });

  if (solutionsMobile.matches) gsap.set(track, { clearProps: 'transform' });
  lockDescWidth();
  goTo(0, true);
}

// відгуки: безперервна стрічка з рівномірним рухом (як на поточному сайті
// Dragin). Наведення курсора зупиняє рух, відведення — плавно відновлює.
// Трек дублюється, поки не покриє дві ширини вʼюпорта, і після проходження
// одного набору оригіналів позиція скидається — шов непомітний.
// Скейл з макета (центр 1 / сусіди .875 / крайні .78 і прозорість
// 1 / .85 / .6) збережено, але як неперервну функцію відстані картки від
// центру екрана — тож під час руху він змінюється плавно, без "клацань".
// Скейл завжди на картку цілком: контент усередині не зсувається
function initTestimonialsSlider() {
  var viewport = document.querySelector('.testimonials__items');
  if (!viewport) return;

  var originals = Array.prototype.slice.call(viewport.children);
  if (originals.length < 2) return;

  var SPEED = 60;       // px/с
  var EASE_TIME = .6;   // сек, розгін/гальмування при ховері
  var GOTO_TIME = .9;   // сек, переїзд до клікнутої картки
  // профіль по відстані від центру, у кроках (ширина картки + гап):
  // 0 — центр, 1 — сусіди, 2 і далі — крайні
  var SCALES = [1, .875, .78];
  var OPACITIES = [1, .85, .6];
  var flat = window.matchMedia('(max-width: 479px)'); // на мобілці без скейлу

  var track = document.createElement('div');
  track.className = 'testimonials__track';
  originals.forEach(function (el) {
    track.appendChild(el);
  });
  viewport.appendChild(track);
  viewport.classList.add('is-marquee');

  var setWidth = 0;   // ширина одного набору оригіналів разом із гапом
  var cardWidth = 0;
  var gap = 0;
  var cards = [];     // усі картки треку разом із клонами
  var position = 0;
  var velocity = 1;   // 0..1, частка SPEED — для плавної паузи
  var targetVelocity = 1;
  var lastTime = null;
  var goto = null;    // активний переїзд до картки: { from, to, start }

  // дублюємо набір, поки трек не перекриє вʼюпорт з запасом на скидання
  function fillTrack() {
    Array.prototype.slice.call(track.children).slice(originals.length).forEach(function (el) {
      track.removeChild(el);
    });
    gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    cardWidth = originals[0].offsetWidth;
    var last = originals[originals.length - 1];
    setWidth = last.offsetLeft + last.offsetWidth + gap - originals[0].offsetLeft;
    if (!setWidth) return;
    // на мобілці стрічку гортають руками (нативний свайп) — клони
    // не потрібні, користувач свайпає лише реальний набір карток
    var need = flat.matches ? 1 : Math.ceil((viewport.clientWidth * 2) / setWidth) + 1;
    for (var i = 1; i < need; i++) {
      originals.forEach(function (el) {
        var clone = el.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
    }
    // offsetLeft кешується: читати його щокадру означало б форсити layout
    cards = Array.prototype.slice.call(track.children).map(function (el) {
      return { el: el, left: el.offsetLeft };
    });
  }

  // лінійна інтерполяція профілю між цілими кроками від центру
  function profile(table, d) {
    if (d >= table.length - 1) return table[table.length - 1];
    var i = Math.floor(d);
    var t = d - i;
    return table[i] + (table[i + 1] - table[i]) * t;
  }

  // Скейл стискає картку до її центру, і між картками росли б діри.
  // Тому візуальні центри розкладаються кумулятивно: сусіди стоять
  // рівно через gap + W·(sᵢ+sᵢ₊₁)/2. А щоб прив'язка ряду до центру
  // екрана була неперервною (дискретна "найближча картка" давала стрибок
  // при зміні лідера), ряд зсувається так, щоб точка, яка номінально
  // лежить у центрі екрана, і візуально опинилась у центрі — її положення
  // інтерполюється між двома сусідніми картками
  var scaleBuf = [], visualBuf = [], nominalBuf = [];

  function layout() {
    var n = cards.length;
    if (!n) return;
    if (flat.matches) {
      cards.forEach(function (c) {
        c.el.style.transform = '';
        c.el.style.opacity = '';
      });
      return;
    }
    var step = cardWidth + gap;
    var center = viewport.clientWidth / 2;
    var limit = viewport.clientWidth + step * 2;
    var i;

    for (i = 0; i < n; i++) {
      nominalBuf[i] = cards[i].left + cardWidth / 2 - position;
      scaleBuf[i] = profile(SCALES, Math.abs(nominalBuf[i] - center) / step);
    }

    visualBuf[0] = nominalBuf[0];
    for (i = 1; i < n; i++) {
      visualBuf[i] = visualBuf[i - 1] + cardWidth * (scaleBuf[i - 1] + scaleBuf[i]) / 2 + gap;
    }

    // картка зліва від центру (k) і частка шляху до наступної (t)
    var k = 0;
    while (k < n - 2 && nominalBuf[k + 1] <= center) k++;
    var t = Math.min(1, Math.max(0, (center - nominalBuf[k]) / step));
    var anchor = visualBuf[k] + (visualBuf[k + 1] - visualBuf[k]) * t;
    var shift = center - anchor;

    for (i = 0; i < n; i++) {
      var c = cards[i];
      var visual = visualBuf[i] + shift;
      // далеко за межами екрана нічого не рахуємо — і так не видно
      if (visual < -step * 2 || visual > limit) {
        c.el.style.opacity = '0';
        continue;
      }
      var d = Math.abs(nominalBuf[i] - center) / step;
      c.el.style.transform = 'translate3d(' + (visual - nominalBuf[i]).toFixed(2) + 'px, 0, 0) scale(' + scaleBuf[i].toFixed(4) + ')';
      c.el.style.opacity = profile(OPACITIES, d).toFixed(3);
    }
  }

  function apply() {
    // у свайп-режимі трек стоїть на місці — його гортає нативний скрол
    if (flat.matches) {
      track.style.transform = '';
      layout();
      return;
    }
    track.style.transform = 'translate3d(' + (-position) + 'px, 0, 0)';
    layout();
  }

  function tick(time) {
    // на мобілці автопрокрутки немає: стрічку веде свайп користувача;
    // rAF-цикл лишається живим на випадок повернення на десктоп
    if (flat.matches) {
      lastTime = time;
      requestAnimationFrame(tick);
      return;
    }
    if (lastTime === null) lastTime = time;
    var dt = Math.min((time - lastTime) / 1000, .1); // сон вкладки не дає стрибка
    lastTime = time;

    // швидкість підтягується до цільової експоненційно — без ривка на
    // вході/виході курсора
    velocity += (targetVelocity - velocity) * Math.min(1, dt / EASE_TIME * 3);
    if (Math.abs(targetVelocity - velocity) < .001) velocity = targetVelocity;

    if (goto) {
      // переїзд по кліку: easeInOut, автопрокрутка в цей час не рухає
      var p = Math.min(1, (time - goto.start) / (GOTO_TIME * 1000));
      var e = p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      position = goto.from + (goto.to - goto.from) * e;
      if (p >= 1) goto = null;
      while (position < 0) position += setWidth;
      while (position >= setWidth) position -= setWidth;
      apply();
    } else if (velocity > 0 && setWidth) {
      position += SPEED * velocity * dt;
      if (position >= setWidth) position -= setWidth;
      apply();
    }
    requestAnimationFrame(tick);
  }

  // клік по картці — стрічка доїжджає так, щоб ця картка стала в центр;
  // напрямок — найкоротший по колу (усі клони еквівалентні)
  track.addEventListener('click', function (e) {
    // у свайп-режимі тап по картці нічого не возить
    if (flat.matches) return;
    var item = e.target.closest('.testimonials-item');
    if (!item || !setWidth) return;
    var card = null;
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].el === item) card = cards[i];
    }
    if (!card) return;
    var target = card.left + cardWidth / 2 - viewport.clientWidth / 2;
    var delta = (target - position) % setWidth;
    if (delta > setWidth / 2) delta -= setWidth;
    if (delta < -setWidth / 2) delta += setWidth;
    if (Math.abs(delta) < 1) return;
    goto = { from: position, to: position + delta, start: performance.now() };
  });

  // пауза лише для курсора: на тач-пристроях mouseenter не має сенсу
  if (window.matchMedia && matchMedia('(hover: hover)').matches) {
    viewport.addEventListener('mouseenter', function () {
      targetVelocity = 0;
    });
    viewport.addEventListener('mouseleave', function () {
      targetVelocity = 1;
    });
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      fillTrack();
      if (setWidth) position = position % setWidth;
      apply();
    }, 150);
  });

  // перемикання режимів: на мобілці — нативний свайп зі снапом (клас
  // is-swipe вмикає overflow-x у CSS, клони знімаються), на десктопі —
  // безперервна стрічка з клонами
  function syncMode() {
    if (flat.matches) {
      viewport.classList.add('is-swipe');
      position = 0;
      goto = null;
    } else {
      viewport.classList.remove('is-swipe');
    }
    viewport.scrollLeft = 0;
    fillTrack();
    apply();
  }
  if (flat.addEventListener) {
    flat.addEventListener('change', syncMode);
  } else if (flat.addListener) {
    // старі Safari без addEventListener на MediaQueryList
    flat.addListener(syncMode);
  }

  syncMode();
  requestAnimationFrame(tick);
  // шрифти/лого можуть змінити ширину карток уже після ініту
  window.addEventListener('load', fillTrack);
}

function initProductAccordion() {
  if (typeof gsap === 'undefined') return;

  var containers = Array.prototype.slice.call(document.querySelectorAll('.product__items'));
  containers.forEach(initProductItems);
}

// кожна секція — свій незалежний акордеон зі своїм активним айтемом
function initProductItems(container) {
  var items = Array.prototype.slice.call(container.querySelectorAll('.product-item'));
  if (!items.length) return;

  var STEP_TIME = 5;    // сек, фолбек для пунктів без відео (статус-бар)
  var LOAD_WAIT = 1500; // мс очікування даних відео перед стартом play()
  var STALL_TIME = 2500; // мс, вікно перевірки руху currentTime
  // мінімум відтвореного часу за вікно STALL_TIME, щоб вважати, що відео
  // реально їде (0.5с/2.5с = 20% швидкості): на повільній мережі ролик
  // повзе по 0.1с/с — раніше це проходило поріг "є рух" і бар висів
  // біля нуля, хоча дивитись на це було неможливо
  var STALL_MIN_PROGRESS = 0.5;

  var activeItem = null;
  var productMobile = window.matchMedia('(max-width: 479px)');

  // таймер перемикання пунктів іде лише коли секція у вʼюпорті:
  // поза екраном активний твін прогрес-бара ставиться на паузу
  var activeBarTween = null;

  // observer спрацьовує асинхронно, а перший айтем відкривається одразу:
  // без синхронного стартового значення перше відео ставилось на паузу
  // одразу після play() і його проміс падав з AbortError
  var inView = (function () {
    var r = container.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.bottom > 0 && r.top < vh;
  })();

  // якщо у пункта є відео — прогрес-бар веде саме воно: ширина =
  // currentTime / duration, а наступний пункт вмикається по ended
  var activeDriver = null; // { video, raf, onEnded, onError }

  // відео активного пункту (навіть коли бар веде таймер-фолбек):
  // на iOS у режимі енергозбереження автоплей заборонено і play() без
  // жесту падає — тому на будь-який тап у секції пробуємо запустити
  // активний ролик прямо з обробника жесту, де це дозволено
  var activeVideo = null;

  function stopDriver() {
    if (!activeDriver) return;
    cancelAnimationFrame(activeDriver.raf);
    clearTimeout(activeDriver.stall);
    activeDriver.video.removeEventListener('ended', activeDriver.onEnded);
    activeDriver.video.removeEventListener('error', activeDriver.onError);
    activeDriver.video.loop = true;
    activeDriver = null;
  }

  var observer = new IntersectionObserver(function (entries) {
    // записи можуть прийти пачкою — актуальний стан у останнього
    inView = entries[entries.length - 1].isIntersecting;
    if (activeBarTween) {
      if (inView) {
        activeBarTween.play();
      } else {
        activeBarTween.pause();
      }
    }
    if (activeDriver) {
      if (inView) {
        var p = activeDriver.video.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        activeDriver.video.pause();
      }
    }
    // поріг нульовий: розкритий акордеон на мобілці вищий за кілька
    // екранів і 15% його площі не видно ніколи — секція вважалась би
    // такою, що поза вʼюпортом, а отже прогрес-бар стояв би на паузі,
    // а відео не грали б. Нуль збігається зі стартовим inView вище
  }, { threshold: 0 });
  observer.observe(container);

  // розлочка для iOS: тап у межах секції — легальний жест, з якого можна
  // запустити ролик, навіть коли автоплей заблоковано (енергозбереження,
  // Low Data Mode). Якщо активне відео стоїть, хоч має грати — пробуємо
  function kickActiveVideo() {
    if (!activeVideo || !inView || !activeVideo.paused) return;
    var p = activeVideo.play();
    if (p && p.catch) p.catch(function () {});
  }
  container.addEventListener('touchend', kickActiveVideo, { passive: true });
  container.addEventListener('click', kickActiveVideo);

  // картинки вантажимо одразу, щоб не довантажувались посеред розкриття
  Array.prototype.forEach.call(container.querySelectorAll('.product-item__body img'), function (img) {
    img.loading = 'eager';
  });

  // у розмітці на всіх відео стоїть preload="auto", і на мобільній мережі
  // два десятки роликів качаються одночасно, забивають канал і активне
  // відео буферизується вічно — currentTime повзе, прогрес-бар (він веде
  // від відео) стоїть біля нуля. Тому джерело знімаємо зовсім (елемент
  // без src гарантовано нічого не качає — preload='none' + load() Chrome
  // для відео з <source> не завжди обриває) і повертаємо його лише
  // активному ролику та прогріву наступного (demote/promote нижче)
  function demoteVideo(video) {
    var srcEl = video.querySelector('source');
    var url = video.getAttribute('src') || (srcEl && srcEl.getAttribute('src'));
    if (!url) return;
    video._lazySrc = url;
    Array.prototype.forEach.call(video.querySelectorAll('source'), function (s) {
      s.parentNode.removeChild(s);
    });
    video.removeAttribute('src');
    video.preload = 'none';
    if (video.load) video.load();
  }

  function promoteVideo(video) {
    if (!video._lazySrc || video.getAttribute('src')) return;
    video.preload = 'auto';
    video.src = video._lazySrc;
    if (video.load) video.load();
  }

  Array.prototype.forEach.call(container.querySelectorAll('.product-item__body video'), function (video) {
    demoteVideo(video);
  });

  // ілюстрація — це або сам <video> (нова розмітка, .w-embed), або
  // обгортка з відео всередині (стара)
  function visualVideo(vis) {
    return vis.tagName === 'VIDEO' ? vis : vis.querySelector('video');
  }

  var data = items.map(function (item) {
    // висоти анімує CSS (grid-template-rows 0fr/1fr на .product-item__collapse),
    // тому тіло айтема загортаємо в обгортку; у сингл-варіанті обгортка
    // вже є в розмітці — використовуємо її
    var body = item.querySelector('.product-item__body');
    var collapse = item.querySelector('.product-item__collapse');
    if (!collapse) {
      collapse = document.createElement('div');
      collapse.className = 'product-item__collapse';
      body.parentNode.insertBefore(collapse, body);
      collapse.appendChild(body);
    }

    var subs = Array.prototype.slice.call(item.querySelectorAll('.product-item-list-item')).map(function (li) {
      // прогрес-бар може бути вже в розмітці — тоді використовуємо його
      var bar = li.querySelector('.product-item-list-item__progress');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'product-item-list-item__progress';
        li.appendChild(bar);
      }
      return {
        el: li,
        head: li.querySelector('.product-item-list-item__head'),
        bar: bar,
        // data-start-video="0.5" — відео пункту стартує з цієї секунди,
        // прогрес-бар рахується від неї ж
        start: parseFloat(li.getAttribute('data-start-video')) || 0,
        // data-video-end="14" — пункт завершується на цій секунді, не
        // чекаючи природного кінця ролика
        end: parseFloat(li.getAttribute('data-video-end')) || null
      };
    });
    // ілюстрації йдуть у тому ж порядку, що й пункти списку; збираємо їх
    // до створення інтро-відео, щоб воно не потрапило в цей список
    var visuals = Array.prototype.slice.call(item.querySelectorAll('.product-item__illustration'));

    // data-main-video — інтро-ролик айтема: створюється окремим шаром
    // грід-стопки, грає один раз за завантаження сторінки при першому
    // відкритті айтема, після нього стартує звичайний цикл пунктів
    var mainVis = null;
    var mainSrc = item.getAttribute('data-main-video');
    var visualBox = item.querySelector('.product-item__visual');
    if (mainSrc && visualBox) {
      mainVis = document.createElement('video');
      mainVis.className = 'product-item__illustration';
      mainVis.muted = true;
      mainVis.playsInline = true;
      mainVis.setAttribute('muted', '');
      mainVis.setAttribute('playsinline', '');
      // джерело не підключаємо — інтро вантажиться лише при відкритті
      // айтема (promoteVideo у playFrom), як і решта роликів
      mainVis.preload = 'none';
      mainVis._lazySrc = mainSrc;
      visualBox.appendChild(mainVis);
    }

    return {
      el: item,
      head: item.querySelector('.product-item__head'),
      subs: subs,
      visuals: visuals,
      visualBox: visualBox,
      // рідне місце блока ілюстрацій у сітці айтема — щоб повернути його
      // з мобільного списку при переході на десктопний брейкпоінт
      visualHome: visualBox
        ? { parent: visualBox.parentNode, next: visualBox.nextSibling }
        : null,
      activeSub: null,
      mainVis: mainVis,
      mainPlayed: false
    };
  });

  // усі відео секції мають autoplay — браузер крутить їх у фоні з моменту
  // завантаження, і при відкритті пункту кадр виявляється не з початку.
  // Знімаємо autoplay і зупиняємо: грає лише активне відео, і лише за
  // нашою командою
  Array.prototype.forEach.call(container.querySelectorAll('.product-item__illustration'), function (vis) {
    // вебфлоушний скрипт фонового відео читає data-autoplay з обгортки —
    // вимикаємо і його, щоб він не запускав ролики повторно
    vis.setAttribute('data-autoplay', 'false');
    var video = visualVideo(vis);
    if (!video) return;
    video.removeAttribute('autoplay');
    video.autoplay = false;
    video.pause();
    seekTo(video, 0);
  });

  // перемотка з гарантією: до loadedmetadata seek може бути проігнорований,
  // тому в такому разі чекаємо метадані й ставимо час уже після них
  function seekTo(video, time) {
    if (video.readyState >= 1) {
      video.currentTime = time;
      return;
    }
    var onMeta = function () {
      video.removeEventListener('loadedmetadata', onMeta);
      video.currentTime = time;
    };
    video.addEventListener('loadedmetadata', onMeta);
  }

  // запуск із заданої секунди. Якщо викликати play() одразу після
  // currentTime = t, поки кадрів ще немає, Safari (а іноді й Chrome)
  // ігнорує seek і стартує з поточної позиції. Тому послідовно: пауза →
  // дочекатись даних (loadeddata) → seek → дочекатись seeked → play().
  // Повертає проміс, який завершується як play() (reject — якщо автоплей
  // заблоковано). Повторний виклик для того ж відео скасовує попередній
  function playFrom(video, time) {
    var token = (video._playToken || 0) + 1;
    video._playToken = token;
    video.pause();

    function stale() {
      return video._playToken !== token;
    }

    function once(ev) {
      return new Promise(function (resolve) {
        var h = function () {
          video.removeEventListener(ev, h);
          resolve();
        };
        video.addEventListener(ev, h);
      });
    }

    function waitMs(ms) {
      return new Promise(function (resolve) { setTimeout(resolve, ms); });
    }

    // iOS не буферизує відео без жесту користувача: preload="auto" він
    // ігнорує, readyState лишається 0, а loadeddata не настає ніколи —
    // і ланцюжок просто не доходив би до play() (навіть без помилки, тож
    // і фолбек не спрацьовував). Чекаємо дані не довше LOAD_WAIT, далі
    // стартуємо як є: сам виклик play() і дотягує завантаження.
    // Неактивні відео стоять без джерела (demoteVideo в init) — активному
    // його повертаємо; вже промоутнуте (прогрів) не перезапускаємо
    var ready = video.readyState >= 2 ? Promise.resolve() : (function () {
      promoteVideo(video);
      return Promise.race([once('loadeddata'), waitMs(LOAD_WAIT)]);
    })();

    return ready.then(function () {
      if (stale()) return;
      // вже стоїть на потрібному кадрі — seeked не настане, не чекаємо
      if (Math.abs(video.currentTime - time) < 0.02) return;
      // без метаданих seek теж може зависнути — та сама страховка
      var seeked = Promise.race([once('seeked'), waitMs(LOAD_WAIT)]);
      video.currentTime = time;
      return seeked;
    }).then(function () {
      // поза вʼюпортом не стартуємо: observer запустить, коли секція
      // зʼявиться — кадр уже стоїть на потрібній секунді
      if (stale() || !inView) return;
      return video.play();
    });
  }

  // показуємо ілюстрацію активного пункту, її відео — зі стартової позиції
  // пункту (data-start-video, за замовчуванням 0); решту ставимо на паузу,
  // щоб не крутились у фоні.
  // Повертає проміс play() активного відео (або null, якщо відео немає)
  function showVisual(d, index, start) {
    var result = null;
    // перехід до пунктів ховає інтро-ролик, якщо він ще видимий
    if (d.mainVis) {
      d.mainVis.classList.remove('is-active');
      d.mainVis.pause();
    }
    d.visuals.forEach(function (vis, i) {
      var video = visualVideo(vis);
      if (i === index) {
        vis.classList.add('is-active');
        if (video) {
          var playing = playFrom(video, start || 0);
          playing.catch(function () {});
          result = { video: video, playing: playing, start: start || 0 };
        }
      } else {
        vis.classList.remove('is-active');
        if (video) video.pause();
      }
    });
    return result;
  }

  // фолбек: бар заповнюється за STEP_TIME, коли відео немає або воно
  // не може відтворитись (заблокований автоплей, помилка завантаження)
  function startTimedBar(d, index, bar) {
    stopDriver();
    gsap.killTweensOf(bar);
    activeBarTween = gsap.fromTo(bar, { width: 0 }, {
      width: '100%',
      duration: STEP_TIME,
      ease: 'none',
      onComplete: function () {
        activateSub(d, (index + 1) % d.subs.length);
      }
    });
    if (!inView) activeBarTween.pause();
  }

  function startVideoBar(d, index, bar, media) {
    var video = media.video;
    activeBarTween = null;
    gsap.set(bar, { width: 0 });
    // loop вимикаємо, інакше ended ніколи не настане
    video.loop = false;

    var driver = {
      video: video,
      raf: 0,
      onEnded: function () {
        gsap.set(bar, { width: '100%' });
        activateSub(d, (index + 1) % d.subs.length);
      },
      onError: function () {
        startTimedBar(d, index, bar);
      }
    };

    var start = media.start || 0;
    // ранній фініш пункту (data-video-end): бар рахується до цієї
    // позначки, і по її досягненні пункт перемикається, як по ended
    var endAt = d.subs[index] ? d.subs[index].end : null;

    function tick() {
      var dur = video.duration;
      var stop = dur && isFinite(dur) ? dur : null;
      if (endAt && (!stop || endAt < stop)) stop = endAt;
      if (stop && stop > start) {
        var p = (video.currentTime - start) / (stop - start);
        gsap.set(bar, { width: (Math.min(1, Math.max(0, p)) * 100) + '%' });
        if (endAt && video.currentTime >= endAt) {
          gsap.set(bar, { width: '100%' });
          activateSub(d, (index + 1) % d.subs.length);
          return; // activateSub уже зупинив драйвер — кадр не плануємо
        }
      }
      driver.raf = requestAnimationFrame(tick);
    }

    video.addEventListener('ended', driver.onEnded);
    video.addEventListener('error', driver.onError);
    activeDriver = driver;
    tick();

    // play() може не впасти з помилкою, а просто не поїхати: режим
    // енергозбереження на iOS, ролик не добуферився, вкладка ожила без
    // жесту. Тоді бар стояв би на нулі, а пункт не перемкнувся б ніколи.
    // Тому стежимо за реальним рухом currentTime, і якщо його немає —
    // далі веде таймер. Заразом ловить і зависання посеред ролика
    var lastTime = start;
    function armStall() {
      clearTimeout(driver.stall);
      driver.stall = setTimeout(function () {
        if (activeDriver !== driver) return;
        // поза вʼюпортом відео стоїть навмисне — просто чекаємо далі
        if (!inView) { armStall(); return; }
        var t = video.currentTime;
        if (t > lastTime + STALL_MIN_PROGRESS) { lastTime = t; armStall(); return; }
        startTimedBar(d, index, bar);
      }, STALL_TIME);
    }
    armStall();

    if (!inView) video.pause();

    if (media.playing && media.playing.catch) {
      media.playing.catch(function (err) {
        // AbortError — play() перервали нашим же pause() (секція поза
        // вʼюпортом): відео просто чекає, observer його запустить.
        // Решта (NotAllowedError — заблокований автоплей) → таймерний
        // фолбек, щоб бар не зависнув на нулі
        if (err && err.name === 'AbortError') return;
        if (activeDriver !== driver) return;
        startTimedBar(d, index, bar);
      });
    }
  }

  // поки грає активний ролик, наступний пункт вантажиться у фоні — один,
  // а не всі одразу: перемикання лишається миттєвим, канал вільний
  function warmNext(d, index) {
    if (!d.visuals.length) return;
    var vis = d.visuals[(index + 1) % d.visuals.length];
    var video = vis && visualVideo(vis);
    if (video) promoteVideo(video);
  }

  // на мобілці блок з відео живе всередині списку пунктів: він
  // переставляється безпосередньо перед активний пункт (тобто одразу після
  // заголовка попереднього), і його описання розкривається вже під своїм
  // заголовком нижче відео — як у дизайні, де ролик "крокує" списком.
  // Прогрес-бар активного пункту при цьому стає смужкою під відео
  function placeVisual(d, index) {
    if (!d.visualBox || !productMobile.matches) return;
    var sub = d.subs[index];
    if (!sub || !sub.el.parentNode) return;
    if (d.visualBox.nextSibling === sub.el) return;
    sub.el.parentNode.insertBefore(d.visualBox, sub.el);
  }

  // на десктопі відео — ліва колонка сітки айтема: повертаємо блок на
  // рідне місце, якщо мобільна логіка встигла його переставити
  function restoreVisual(d) {
    if (!d.visualBox || !d.visualHome) return;
    if (d.visualBox.parentNode === d.visualHome.parent && d.visualBox.nextSibling === d.visualHome.next) return;
    d.visualHome.parent.insertBefore(d.visualBox, d.visualHome.next);
  }

  // активний пункт списку розкривається через клас is-active, його
  // статус-бар заповнюється за STEP_TIME, далі — наступний пункт по колу
  function activateSub(d, index) {
    stopDriver();
    d.activeSub = index;
    // спершу DOM-переміщення, і лише потім запуск ролика: переставляння
    // <video> у документі може поставити відтворення на паузу
    placeVisual(d, index);
    var media = d.visuals.length
      ? showVisual(d, index % d.visuals.length, d.subs[index] ? d.subs[index].start : 0)
      : null;
    activeVideo = media ? media.video : null;
    warmNext(d, index);
    d.subs.forEach(function (sub, i) {
      gsap.killTweensOf(sub.bar);
      if (i === index) {
        sub.el.classList.add('is-active');
        if (media) {
          startVideoBar(d, index, sub.bar, media);
        } else {
          startTimedBar(d, index, sub.bar);
        }
      } else {
        sub.el.classList.remove('is-active');
        gsap.set(sub.bar, { width: 0 });
      }
    });
  }

  function stopSubs(d) {
    stopDriver();
    activeBarTween = null;
    activeVideo = null;
    d.subs.forEach(function (sub) {
      gsap.killTweensOf(sub.bar);
      gsap.set(sub.bar, { width: 0 });
      sub.el.classList.remove('is-active');
    });
    // у згорнутому айтемі відео не мають крутитись у фоні
    d.visuals.forEach(function (vis) {
      var video = visualVideo(vis);
      if (video) video.pause();
    });
    if (d.mainVis) {
      d.mainVis.classList.remove('is-active');
      d.mainVis.pause();
    }
  }

  // інтро-ролик айтема (data-main-video): показується один раз за
  // завантаження сторінки; по завершенні — звичайний цикл пунктів.
  // Клік по пункту списку в цей час перериває інтро (через activateSub).
  // Пункти списку йдуть синхронно з інтро: ролик — це "глави" в порядку
  // пунктів, активний пункт визначається за currentTime, його бар —
  // прогрес усередині глави. Межі глав задаються атрибутом
  // data-main-chapters="0,12,24,36" (секунди початку кожного пункту)
  // на айтемі; без атрибута тривалість ділиться порівну
  function playMain(d) {
    d.mainPlayed = true;
    stopDriver();
    activeBarTween = null;
    d.subs.forEach(function (sub) {
      gsap.killTweensOf(sub.bar);
      gsap.set(sub.bar, { width: 0 });
      sub.el.classList.remove('is-active');
    });
    d.visuals.forEach(function (vis) {
      vis.classList.remove('is-active');
      var video = visualVideo(vis);
      if (video) video.pause();
    });

    var video = d.mainVis;
    video.classList.add('is-active');
    video.loop = false;
    activeVideo = video;

    var chaptersAttr = (d.el.getAttribute('data-main-chapters') || '').trim();
    var chapters = chaptersAttr
      ? chaptersAttr.split(',').map(parseFloat).filter(function (x) { return !isNaN(x); })
      : null;

    function chapterStarts(dur) {
      if (chapters && chapters.length) return chapters;
      var starts = [];
      for (var i = 0; i < d.subs.length; i++) starts.push(dur * i / d.subs.length);
      return starts;
    }

    // через activeDriver інтро, як і решта відео, ставиться на паузу
    // поза вʼюпортом і відновлюється при поверненні
    var driver = {
      video: video,
      raf: 0,
      onEnded: function () {
        activateSub(d, 0);
      },
      onError: function () {
        activateSub(d, 0);
      }
    };

    // до loadedmetadata тривалості немає — кадри просто пропускаються
    function syncTick() {
      var dur = video.duration;
      if (dur && isFinite(dur) && d.subs.length) {
        var t = video.currentTime;
        var starts = chapterStarts(dur);
        var k = 0;
        for (var i = 0; i < starts.length && i < d.subs.length; i++) {
          if (t >= starts[i]) k = i;
        }
        d.subs.forEach(function (sub, i) {
          if (i === k) {
            sub.el.classList.add('is-active');
            var end = k + 1 < starts.length ? starts[k + 1] : dur;
            var p = end > starts[k] ? (t - starts[k]) / (end - starts[k]) : 0;
            gsap.set(sub.bar, { width: (Math.min(1, Math.max(0, p)) * 100) + '%' });
          } else {
            sub.el.classList.remove('is-active');
            gsap.set(sub.bar, { width: 0 });
          }
        });
      }
      driver.raf = requestAnimationFrame(syncTick);
    }

    video.addEventListener('ended', driver.onEnded);
    video.addEventListener('error', driver.onError);
    activeDriver = driver;
    syncTick();

    // якщо інтро не поїхало (те саме, що й у пунктах: play() не впав, а
    // просто завис) — не тримаємо айтем заручником, вмикаємо пункти
    var introTime = 0;
    function armIntroStall() {
      clearTimeout(driver.stall);
      driver.stall = setTimeout(function () {
        if (activeDriver !== driver) return;
        if (!inView) { armIntroStall(); return; }
        var t = video.currentTime;
        if (t > introTime + STALL_MIN_PROGRESS) { introTime = t; armIntroStall(); return; }
        activateSub(d, 0);
      }, STALL_TIME);
    }
    armIntroStall();

    playFrom(video, 0).catch(function (err) {
      // AbortError — пауза нашим же pause() поза вʼюпортом, observer
      // відновить; решта (заблокований автоплей тощо) → одразу пункти
      if (err && err.name === 'AbortError') return;
      if (activeDriver !== driver) return;
      activateSub(d, 0);
    });
  }

  function openItem(d, subIndex) {
    if (activeItem && activeItem !== d) closeItem(activeItem);
    activeItem = d;
    d.el.classList.add('is-open');
    // перше відкриття айтема з data-main-video починається з інтро-ролика;
    // відкриття кліком по конкретному пункту списку пропускає його
    if (subIndex == null && d.mainVis && !d.mainPlayed) {
      playMain(d);
    } else {
      activateSub(d, subIndex || 0);
    }
  }

  function closeItem(d) {
    if (activeItem === d) activeItem = null;
    d.el.classList.remove('is-open');
    stopSubs(d);
  }

  data.forEach(function (d) {
    // у сингл-варіанті шапки немає — айтем відкритий постійно
    if (d.head) {
      d.head.addEventListener('click', function () {
        if (activeItem === d) {
          closeItem(d);
        } else {
          openItem(d);
          // на мобілці відкритий айтем часто опиняється поза екраном —
          // після завершення анімації висот (0.5s) підскролюємо до
          // його верху з поправкою на фіксований навбар
          if (productMobile.matches) {
            setTimeout(function () {
              var nav = document.querySelector('.navbar');
              var offset = (nav ? nav.offsetHeight : 0) + 8;
              window.scrollTo({
                top: d.el.getBoundingClientRect().top + window.scrollY - offset,
                behavior: 'smooth'
              });
            }, 550);
          }
        }
      });
    }

    d.subs.forEach(function (sub, si) {
      if (!sub.head) return;
      sub.head.addEventListener('click', function () {
        if (activeItem !== d) {
          openItem(d, si);
        } else {
          activateSub(d, si);
        }
      });
    });
  });

  // перетин брейкпоінта: на мобілці відео їде в список до активного
  // пункту, на десктопі — назад у свою колонку сітки
  function syncVisualPlacement() {
    data.forEach(function (d) {
      if (productMobile.matches) {
        if (activeItem === d && d.activeSub != null) placeVisual(d, d.activeSub);
      } else {
        restoreVisual(d);
      }
    });
  }
  if (productMobile.addEventListener) {
    productMobile.addEventListener('change', syncVisualPlacement);
  } else if (productMobile.addListener) {
    // старі Safari без addEventListener на MediaQueryList
    productMobile.addListener(syncVisualPlacement);
  }

  if (data.length) openItem(data[0]);
}

// відео в картках бенефітів керує один атрибут обгортки — data-video-active="1-3"
// (секунди від/до): цей шматок крутиться лупом, поки картка у в'юпорті.
// Ховер відео НЕ чіпає (по коменту дизайну ховер-стейт роликів прибрано;
// реакція картки на курсор — чисто візуальна, в CSS: крок уперед + тінь).
// На мобілці обгортка .mobile-hidden прихована (display: none), тому
// observer не бачить її як видиму і відео там не грають узагалі
function initBenefitsVideos() {
  var boxes = Array.prototype.slice.call(document.querySelectorAll('[data-video-active]'));
  if (!boxes.length) return;

  var items = [];
  var raf = 0;

  // "1-3" -> { from: 1, to: 3 }; "3" -> { from: 3, to: null } (без верхньої межі)
  function parseRange(el, name) {
    var raw = (el.getAttribute(name) || '').trim();
    if (!raw) return null;
    var parts = raw.split('-');
    var from = parseFloat(parts[0]);
    if (isNaN(from)) return null;
    var to = parts.length > 1 ? parseFloat(parts[1]) : NaN;
    return { from: from, to: isNaN(to) ? null : to };
  }

  // до loadedmetadata seek може бути проігнорований — тоді чекаємо метадані
  function seekTo(video, time) {
    if (video.readyState >= 1) {
      video.currentTime = time;
      return;
    }
    var onMeta = function () {
      video.removeEventListener('loadedmetadata', onMeta);
      video.currentTime = time;
    };
    video.addEventListener('loadedmetadata', onMeta);
  }

  function start(item) {
    item.playing = true;
    var p = item.video.play();
    if (p && p.catch) p.catch(function () {});
    if (!raf) raf = requestAnimationFrame(tick);
  }

  function stop(item) {
    item.playing = false;
    item.video.pause();
  }

  // межу лупа стережемо на rAF: timeupdate приходить лише ~4 рази на
  // секунду і шматок на 1-3 с обрізався б із помітним перельотом
  function tick() {
    raf = 0;
    var busy = false;
    items.forEach(function (item) {
      if (!item.playing || !item.inView) return;
      busy = true;
      if (item.active.to != null && item.video.currentTime >= item.active.to) {
        item.video.currentTime = item.active.from;
      }
    });
    if (busy) raf = requestAnimationFrame(tick);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var item = entry.target._benefitsVideo;
      if (!item) return;
      item.inView = entry.isIntersecting;
      if (!item.inView) {
        stop(item);
        return;
      }
      // повернулись у вʼюпорт — луп починаємо спочатку
      seekTo(item.video, item.active.from);
      start(item);
    });
  }, { threshold: .25 });

  boxes.forEach(function (box) {
    var video = box.tagName === 'VIDEO' ? box : box.querySelector('video');
    if (!video) return;

    var active = parseRange(box, 'data-video-active');
    if (!active) return;

    // луп тримаємо самі (нативний перезапускав би з нуля, а не з active.from),
    // а вебфлоушному скрипту фонового відео забороняємо чіпати ролик
    box.setAttribute('data-autoplay', 'false');
    box.setAttribute('data-loop', 'false');
    video.removeAttribute('autoplay');
    video.removeAttribute('loop');
    video.autoplay = false;
    video.loop = false;
    video.muted = true;
    video.playsInline = true;
    // на мобілці ці картки сховані (.mobile-hidden), але display: none не
    // зупиняє закачку — preload="auto" з розмітки тягнув би всі ролики й
    // забивав канал відео продукт-секції. Знімаємо джерело зовсім:
    // елемент без src гарантовано нічого не качає (preload='none' +
    // load() Chrome для відео з <source> не завжди обриває)
    if (window.matchMedia('(max-width: 479px)').matches) {
      Array.prototype.forEach.call(video.querySelectorAll('source'), function (s) {
        s.parentNode.removeChild(s);
      });
      video.removeAttribute('src');
      video.preload = 'none';
      if (video.load) video.load();
    } else {
      video.preload = 'auto';
    }
    video.pause();

    var item = {
      box: box,
      video: video,
      active: active,
      inView: false,
      playing: false
    };
    items.push(item);
    box._benefitsVideo = item;
    seekTo(video, active.from);

    observer.observe(box);
  });
}

// мобільні версії карток бенефітів (.benefits-item__photo.mobile-visible):
// autoplay і loop у них вимкнені в розмітці (data-autoplay="false"), тож
// без JS вони стояли постером. Тут — звичайний луп, але лише у вʼюпорті:
// поза екраном відео на паузі, а до першого показу і не вантажиться
// (preload='none' — play() сам дотягне дані). На десктопі ці обгортки
// display: none, observer їх ніколи не бачить — відео там не грають
function initBenefitsMobileVideos() {
  var boxes = Array.prototype.slice.call(document.querySelectorAll('.benefits-item__photo.mobile-visible'));
  if (!boxes.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var video = entry.target._mobileLoopVideo;
      if (!video) return;
      entry.target._inView = entry.isIntersecting;
      if (entry.isIntersecting) {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        video.pause();
      }
    });
  }, { threshold: .25 });

  var tracked = [];
  boxes.forEach(function (box) {
    // ролики з data-video-active веде initBenefitsVideos — не дублюємо
    if (box.hasAttribute('data-video-active')) return;
    var video = box.querySelector('video');
    if (!video) return;
    video.muted = true;
    video.playsInline = true;
    video.loop = true;
    video.preload = 'none';
    // атрибути, а не лише властивості: політика автоплею iOS дивиться
    // на розмітку в момент старту відтворення
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    // декларативний autoplay (стоїть лише в першої картки через
    // data-autoplay="true" у Webflow): саме на таких роликах iOS малює
    // перекреслену кнопку play, коли блокує автозапуск. Браузер пробує
    // автоплей ще на парсингу розмітки — тому мало зняти атрибут,
    // елемент треба перезапустити load(), інакше стан "заблокованого
    // автоплею" разом із кнопкою лишається. Далі ролик стартує observer,
    // як у решти карток
    if (video.hasAttribute('autoplay')) {
      box.setAttribute('data-autoplay', 'false');
      video.removeAttribute('autoplay');
      video.autoplay = false;
      if (video.load) video.load();
    }
    box._mobileLoopVideo = video;
    tracked.push(box);
    observer.observe(box);
  });

  // iOS у режимі енергозбереження блокує автоплей: play() падає, ролик
  // стоїть на паузі, і система малює поверх нього кнопку play. Перший
  // тап — легальний жест користувача, з якого запуск дозволено:
  // пробуємо підняти всі видимі ролики, що стоять
  document.addEventListener('touchend', function () {
    tracked.forEach(function (box) {
      var v = box._mobileLoopVideo;
      if (v && box._inView && v.paused) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
    });
  }, { passive: true });
}

// на мобілці бенефіти — горизонтальна стрічка зі снапом, і тінь має лише
// картка по центру екрана: по скролу стрічки вішаємо .is-centered тій
// картці, чий центр найближчий до центру вʼюпорта (сама тінь і зняття
// вебфлоушної з решти — у _benefits.sass). На десктопі сітка не
// скролиться — класи просто знімаємо
function initBenefitsCenterCard() {
  var body = document.querySelector('.benefits__body');
  if (!body) return;

  var items = Array.prototype.slice.call(body.querySelectorAll('.benefits-item'));
  if (!items.length) return;

  var mobile = window.matchMedia('(max-width: 479px)');
  var raf = 0;

  function update() {
    raf = 0;
    var center = window.innerWidth / 2;
    var best = null;
    var bestDist = Infinity;
    items.forEach(function (item) {
      var r = item.getBoundingClientRect();
      if (!r.width) return; // приховані картки (акцентна на мобілці)
      var d = Math.abs(r.left + r.width / 2 - center);
      if (d < bestDist) {
        bestDist = d;
        best = item;
      }
    });
    items.forEach(function (item) {
      if (item === best) {
        item.classList.add('is-centered');
      } else {
        item.classList.remove('is-centered');
      }
    });
  }

  function schedule() {
    if (!raf) raf = requestAnimationFrame(update);
  }

  function sync() {
    if (mobile.matches) {
      schedule();
    } else {
      if (raf) {
        cancelAnimationFrame(raf);
        raf = 0;
      }
      items.forEach(function (item) {
        item.classList.remove('is-centered');
      });
    }
  }

  // скролиться сама стрічка: overflow-x на .benefits__body
  body.addEventListener('scroll', function () {
    if (mobile.matches) schedule();
  }, { passive: true });
  window.addEventListener('resize', sync);
  if (mobile.addEventListener) {
    mobile.addEventListener('change', sync);
  } else if (mobile.addListener) {
    // старі Safari без addEventListener на MediaQueryList
    mobile.addListener(sync);
  }
  sync();
}

// у розмітці блискавки (.benefits-item-visual-2) бракує смужки dec-2-12, і
// на її місці проглядала розмита блискавка без скла. Поки її немає, ставимо
// туди дубль dec-2-11: у макеті ряд 12 — майже той самий зріз, лише
// зсунутий уліво (зсув — у CSS, .is-duplicate). Щойно справжню смужку
// додадуть у Webflow, дубль не створюється. Окремо від анімацій, бо
// потрібен і з prefers-reduced-motion
function initBenefitsStripsFill() {
  Array.prototype.slice.call(document.querySelectorAll('.benefits-item-visual-2')).forEach(function (visual) {
    var items = Array.prototype.slice.call(visual.querySelectorAll('.benefits-item-visual-2__item'));
    var hasTwelfth = items.some(function (img) {
      return /dec-2-12\./.test(img.getAttribute('src') || '');
    });
    // потрібні dec-2-11 (11-та) і смужка після неї (dec-2-13)
    if (hasTwelfth || items.length < 12) return;
    var copy = items[10].cloneNode(false);
    copy.classList.add('is-duplicate');
    items[10].parentNode.insertBefore(copy, items[11]);
  });
}

// анімації декоративних візуалів у бенефітах (за референс-відео дизайну).
// Базова петля всюди — 2 с, ховер — на всю картку бенефіту:
//  1) картки гойдаються хвилею; на ховері акцентна виїжджає вгору й
//     завмирає, решта гойдаються далі
//  2) блискавка зі скляними смужками пливе вгору-вниз, по смужках згори
//     донизу пробігає відблиск; на ховері скло зникає, а розмита блискавка
//     під ним трохи росте
//  3) іконка з плитками пульсує; на ховері іконка росте, плитки роз'їжджаються
//  4) щит пульсує; на ховері росте
//  5) акцентна картка: сфера з відео у спокої збільшена й опущена, на ховері
//     стискається й стає по центру, заголовок блідне
// Петлі крутяться, лише поки візуал у в'юпорті: під шарами backdrop-filter
// кожен кадр — це перерахунок блюру. Ховер — тільки на пристроях з мишею.
// Амплітуди — у відсотках від розміру елемента, тож рух масштабується разом
// із візуалом. З prefers-reduced-motion лишається статична розкладка
function initBenefitsVisuals() {
  if (typeof gsap === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var PERIOD = 2;
  var canHover = window.matchMedia('(hover: hover)').matches;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var loop = entry.target._benefitsLoop;
      if (!loop) return;
      if (entry.isIntersecting) {
        loop.play();
      } else {
        loop.pause();
      }
    });
  });

  function all(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  // петля грає, поки візуал видно; ховер — на всю картку бенефіту
  function register(visual, loop, onEnter, onLeave) {
    loop.pause();
    visual._benefitsLoop = loop;
    observer.observe(visual);
    if (!canHover) return;
    var card = visual.closest('.benefits-item') || visual;
    card.addEventListener('mouseenter', onEnter);
    card.addEventListener('mouseleave', onLeave);
  }

  // gsap.quickSetter(el, 'scale') у 3.12 мовчки нічого не робить: аліас
  // scale розгортається в "scaleX,scaleY" і пишеться як звичайна
  // властивість елемента. Тож масштаб ставимо двома сеттерами
  function scaleSetter(el) {
    var setX = gsap.quickSetter(el, 'scaleX');
    var setY = gsap.quickSetter(el, 'scaleY');
    return function (value) {
      setX(value);
      setY(value);
    };
  }

  // "двигун" петлі: t біжить 0 → PERIOD, а tick розкладає його на
  // властивості елементів. Одна пауза/старт на весь візуал, а рух можна
  // зважувати: ховер плавно гасить гойдання чи пульс, а не обриває його
  function driver(tick) {
    var state = { t: 0 };
    tick(0);
    return gsap.to(state, {
      t: PERIOD,
      duration: PERIOD,
      ease: 'none',
      repeat: -1,
      onUpdate: function () {
        tick(state.t);
      }
    });
  }

  // 1) хвиля карток: амплітуда ~4.5px при ширині 479 (≈2.1% висоти картки),
  // кожна наступна відстає на .22 с — гребінь біжить зліва направо
  all('.benefits-item-visual-1').forEach(function (visual) {
    var cards = all('.benefits-item-visual-1__dec', visual);
    if (!cards.length) return;
    var accent = visual.querySelector('.benefits-item-visual-1__dec.is-accent');
    var AMP = 2.1;
    var STEP = .22;
    // вага гойдання акцентної: на ховері гасне до 0, і картка завмирає
    var accentSway = { v: 1 };
    var setters = cards.map(function (card) {
      return gsap.quickSetter(card, 'yPercent');
    });

    var loop = driver(function (t) {
      cards.forEach(function (card, i) {
        var w = card === accent ? accentSway.v : 1;
        setters[i](AMP * w * Math.cos(Math.PI * (t - .5 - STEP * i)));
      });
    });

    register(visual, loop, function () {
      if (!accent) return;
      gsap.to(accentSway, { v: 0, duration: .35, ease: 'power2.out', overwrite: true });
      // підйом ~29px при ширині 479 — 13% висоти картки; через y, бо
      // yPercent зайнятий гойданням
      gsap.to(accent, {
        y: function () {
          return -accent.offsetHeight * .13;
        },
        duration: .45,
        ease: 'power3.out',
        overwrite: 'auto'
      });
    }, function () {
      if (!accent) return;
      gsap.to(accentSway, { v: 1, duration: .6, ease: 'power2.inOut', overwrite: true });
      gsap.to(accent, { y: 0, duration: .6, ease: 'power2.inOut', overwrite: 'auto' });
    });
  });

  // 2) блискавка: група пливе на ~4px при висоті 377 (≈1.06% обгортки, яка
  // в CSS розтягнута на контейнер). Відблиск: смужки по черзі на мить
  // світлішають і трохи витягуються вправо; хвиля проходить згори донизу
  // за ~.65 с, раз на період. Світлішає лише кольоровий зріз: contrast <1
  // з brightness >1 тримає на місці тони біля ~240 (світла заливка смужок),
  // а темніші піднімає на 3–10 — як у відео. Чистий brightness білив
  // заливку, і смужки проступали білими прямокутниками
  all('.benefits-item-visual-2').forEach(function (visual) {
    var wrapper = visual.querySelector('.benefits-item-visual-2__wrapper');
    var main = visual.querySelector('.benefits-item-visual-2__main');
    var items = all('.benefits-item-visual-2__item', visual);
    if (!wrapper || !items.length) return;
    var FLOAT = 1.06;
    var GLINT_START = .2;
    var GLINT_STEP = .067;
    var GLINT_HALF = .14;

    gsap.set(items, { transformOrigin: '0% 50%' });

    // синусоїда за період: вниз, угору, назад у нуль
    var loop = gsap.timeline({ repeat: -1 });
    loop.to(wrapper, { yPercent: FLOAT, duration: PERIOD / 4, ease: 'sine.out' }, 0)
      .to(wrapper, { yPercent: -FLOAT, duration: PERIOD / 2, ease: 'sine.inOut' })
      .to(wrapper, { yPercent: 0, duration: PERIOD / 4, ease: 'sine.in' });
    items.forEach(function (item, i) {
      loop.fromTo(item,
        { filter: 'contrast(1) brightness(1)', scaleX: 1 },
        { filter: 'contrast(.88) brightness(1.06)', scaleX: 1.02, duration: GLINT_HALF, ease: 'sine.inOut', yoyo: true, repeat: 1 },
        GLINT_START + GLINT_STEP * i);
    });

    register(visual, loop, function () {
      gsap.to(items, { opacity: 0, duration: .25, ease: 'power1.out', overwrite: 'auto' });
      if (main) gsap.to(main, { scale: 1.07, duration: .35, ease: 'power2.out', overwrite: 'auto' });
    }, function () {
      gsap.to(items, { opacity: 1, duration: .45, ease: 'power1.inOut', overwrite: 'auto' });
      if (main) gsap.to(main, { scale: 1, duration: .35, ease: 'power2.inOut', overwrite: 'auto' });
    });
  });

  // 3) іконка з плитками пульсує на +4% за період; плитки ростуть від
  // зовнішнього краю, тож їхні внутрішні краї ледь підтягуються до іконки
  all('.benefits-item-visual-3').forEach(function (visual) {
    var icon = visual.querySelector('.benefits-item-visual-3__1');
    if (!icon) return;
    var tiles = [
      visual.querySelector('.benefits-item-visual-3__2'),
      visual.querySelector('.benefits-item-visual-3__3')
    ];
    var PULSE = .04;
    var pulse = { w: 1 };
    var hover = { s: 1 };
    var setIcon = scaleSetter(icon);
    var setTiles = tiles.map(function (tile, i) {
      if (!tile) return null;
      gsap.set(tile, { transformOrigin: i ? '100% 50%' : '0% 50%' });
      return scaleSetter(tile);
    });

    var loop = driver(function (t) {
      var p = 1 + PULSE * pulse.w * (1 - Math.cos(Math.PI * t)) / 2;
      setIcon(p * hover.s);
      setTiles.forEach(function (set) {
        if (set) set(p);
      });
    });

    register(visual, loop, function () {
      gsap.to(pulse, { w: 0, duration: .3, overwrite: true });
      gsap.to(hover, { s: 1.14, duration: .35, ease: 'power3.out', overwrite: true });
      // плитки роз'їжджаються на ~20px при ширині 332 — третина їхньої ширини
      tiles.forEach(function (tile, i) {
        if (tile) gsap.to(tile, { xPercent: i ? 33 : -33, duration: .35, ease: 'power3.out', overwrite: 'auto' });
      });
    }, function () {
      gsap.to(pulse, { w: 1, duration: .5, overwrite: true });
      gsap.to(hover, { s: 1, duration: .5, ease: 'power2.inOut', overwrite: true });
      tiles.forEach(function (tile) {
        if (tile) gsap.to(tile, { xPercent: 0, duration: .5, ease: 'power2.inOut', overwrite: 'auto' });
      });
    });
  });

  // 4) щит пульсує на +4% за період (у відео ~2%, але так пульс майже не
  // читався) і росте на ховері. Масштаб іде через CSS-змінну
  // --shield-scale: вона ж масштабує шари блюру щита в CSS
  all('.benefits-item-visual-4').forEach(function (visual) {
    if (!visual.querySelector('.benefits-item-visual-4__illustration')) return;
    var PULSE = .04;
    var pulse = { w: 1 };
    var hover = { s: 1 };

    var loop = driver(function (t) {
      var p = 1 + PULSE * pulse.w * (1 - Math.cos(Math.PI * t)) / 2;
      visual.style.setProperty('--shield-scale', p * hover.s);
    });

    register(visual, loop, function () {
      gsap.to(pulse, { w: 0, duration: .3, overwrite: true });
      gsap.to(hover, { s: 1.12, duration: .35, ease: 'power3.out', overwrite: true });
    }, function () {
      gsap.to(pulse, { w: 1, duration: .4, overwrite: true });
      gsap.to(hover, { s: 1, duration: .4, ease: 'power2.inOut', overwrite: true });
    });
  });

  // 5) акцентна картка (за animation-center.mp4). Спокій — у CSS: сфера
  // велика й опущена. На ховері вона за .6 с стискається й стає по центру
  // (у відео це power2.out): радіус 0.475 висоти картки, тобто 1.74 від
  // радіуса в коробці 4:3 з CSS. Заголовок за .3 с блідне до .3. Петлі тут
  // немає: відео грає своїм лупом (initBenefitsVideos), анімуємо лише ховер
  if (canHover) {
    all('.benefits-item.is-accent').forEach(function (card) {
      var video = card.querySelector('.benefits-item__photo.is-accent video');
      if (!video) return;
      var title = card.querySelector('.benefits-item__title');
      // той самий спокій, що в CSS, але gsap-властивостями: інакше gsap
      // розклав би CSS-матрицю в пікселі і повертав би сферу не туди
      var REST = { xPercent: 6.5, yPercent: 71.3, scale: 3.21 };
      gsap.set(video, { x: 0, y: 0, xPercent: REST.xPercent, yPercent: REST.yPercent, scale: REST.scale });

      card.addEventListener('mouseenter', function () {
        gsap.to(video, { xPercent: 0, yPercent: 0, scale: 1.74, duration: .6, ease: 'power2.out', overwrite: 'auto' });
        if (title) gsap.to(title, { opacity: .3, duration: .3, ease: 'power1.out', overwrite: 'auto' });
      });
      card.addEventListener('mouseleave', function () {
        gsap.to(video, { xPercent: REST.xPercent, yPercent: REST.yPercent, scale: REST.scale, duration: .6, ease: 'power2.out', overwrite: 'auto' });
        if (title) gsap.to(title, { opacity: 1, duration: .3, ease: 'power1.out', overwrite: 'auto' });
      });
    });
  }
}

function initIntegrations() {
  var container = document.querySelector('.integrations__items');
  if (!container || typeof gsap === 'undefined') return;

  var items = Array.prototype.slice.call(container.querySelectorAll('.integrations-item'));
  if (items.length < 2) return;

  // геометрія дуги (частки ширини контейнера), коло відновлене по центрах
  // лого з макетів. Константи:
  //  X_STEP — крок між слотами; R_FACTOR — радіус кола; APEX_Y — зсув
  //  апекса від верху бокса; APEX_DIP — прогин апекса вниз (дуга на
  //  картинці біля вершини пласкіша за коло); VISIBLE — скільки лого
  //  видно з кожного боку (перший сусід d=1 стоїть у слоті 2, далі
  //  айтеми продовжують дугу схованими — там же телепорт через "шов").
  // на мобілці пігулка займає пів екрана, дуга значно пласкіша і видно
  // лише по одному лого з боку — тому власний набір значень
  var mobileQuery = window.matchMedia('(max-width: 479px)');

  function conf() {
    if (mobileQuery.matches) {
      return { X_STEP: .225, R_FACTOR: 1.5, APEX_Y: .03, APEX_DIP: .01, VISIBLE: 1 };
    }
    return { X_STEP: .1025, R_FACTOR: .82, APEX_Y: .015, APEX_DIP: .012, VISIBLE: 3 };
  }

  var C = conf();

  var n = items.length;
  var activeIndex = Math.floor(n / 2);
  var tl = null;

  // ширина контейнера кешується: читати offsetWidth на кожному кадрі
  // між записами позицій означало б форсити layout по разу на айтем
  var width = 0;

  function measure() {
    width = container.offsetWidth;
  }

  // позиції — через transform (x/y), а не left/top: рух іде на
  // композиторі без reflow. Центрування айтема — теж у transform
  gsap.set(items, { xPercent: -50, yPercent: -50, force3D: true });

  // відстань айтема від активного по кільцю, у діапазоні [-n/2, n/2]
  function ringDistance(i) {
    var d = (((i - activeIndex) % n) + n) % n;
    if (d > n / 2) d -= n;
    return d;
  }

  // горизонталь слота: активний в апексі, пігулка накриває сусідні слоти,
  // тому решта починається з другої позиції від центру
  function slotFx(d) {
    if (d === 0) return 0;
    return (Math.abs(d) + 1) * C.X_STEP * (d > 0 ? 1 : -1);
  }

  // вертикаль завжди рахується з кола — тому будь-який рух іде по дузі
  function setPos(item, fx) {
    if (!width) return;
    var fy = C.R_FACTOR - Math.sqrt(Math.max(C.R_FACTOR * C.R_FACTOR - fx * fx, 0));
    // прогин діє в апексі і плавно зникає до другого слота
    fy += C.APEX_DIP * Math.max(0, 1 - Math.abs(fx) / (2 * C.X_STEP));
    gsap.set(item, {
      x: (0.5 + fx) * width,
      y: (C.APEX_Y + fy) * width
    });
  }

  function layout() {
    measure();
    items.forEach(function (item, i) {
      var d = ringDistance(i);
      item._fx = slotFx(d);
      setPos(item, item._fx);
      gsap.set(item, { autoAlpha: Math.abs(d) <= C.VISIBLE ? 1 : 0 });
    });
  }

  function rotateTo(i) {
    if (i === activeIndex) return;
    if (tl) tl.kill();
    items[activeIndex].classList.remove('is-active');
    activeIndex = i;

    measure();
    tl = gsap.timeline();
    items.forEach(function (it, idx) {
      var d = ringDistance(idx);
      var targetFx = slotFx(d);
      var visible = Math.abs(d) <= C.VISIBLE;

      // стрибок через "шов" кільця: обидві точки в схованій зоні,
      // тому просто телепортуємо в середині анімації без прольоту
      // через весь екран
      if (Math.abs(it._fx - targetFx) > C.X_STEP * (C.VISIBLE + 3)) {
        tl.to(it, { autoAlpha: 0, duration: .2, ease: 'power1.out' }, 0);
        tl.call(function () {
          it._fx = targetFx;
          setPos(it, targetFx);
        }, null, .55);
        if (visible) tl.to(it, { autoAlpha: 1, duration: .5, ease: 'power2.out' }, .75);
        return;
      }

      // рух по дузі з ледь помітним хвильовим стаггером від центру;
      // power3.inOut — мʼякий розгін і таке ж гальмування, без
      // "клацання" на старті й фініші, яке давав expo
      var proxy = { fx: it._fx };
      tl.to(proxy, {
        fx: targetFx,
        duration: 1.1,
        ease: 'power3.inOut',
        onUpdate: function () {
          it._fx = proxy.fx;
          setPos(it, proxy.fx);
        }
      }, Math.abs(d) * .03);
      tl.to(it, {
        autoAlpha: visible ? 1 : 0,
        duration: .6,
        ease: 'power2.inOut'
      }, visible ? .3 : .15);
    });

    // пігулка розгортається, коли лого докочується до апекса
    tl.call(function () {
      items[activeIndex].classList.add('is-active');
    }, null, .85);

    // доводчик: після завершення анімації знімаємо всі проміжні стани
    // (актуально після серії швидких кліків з убитими таймлайнами)
    tl.call(layout, null, 1.6);
  }

  // автоплей: раз на 3 секунди наступне лого по кільцю; ручний клік
  // перезапускає відлік
  var AUTOPLAY_DELAY = 3000;
  var autoplayTimer = null;

  function stopAutoplay() {
    if (autoplayTimer) clearInterval(autoplayTimer);
    autoplayTimer = null;
  }

  function startAutoplay() {
    stopAutoplay();
    autoplayTimer = setInterval(function () {
      rotateTo((activeIndex + 1) % n);
    }, AUTOPLAY_DELAY);
  }

  items.forEach(function (item, i) {
    item.addEventListener('click', function () {
      rotateTo(i);
      startAutoplay();
    });
  });

  // свайп на мобілці: вліво — наступне лого, вправо — попереднє. Після
  // свайпу автоплей вимикається зовсім — користувач узяв керування.
  // touch-action: pan-y лишає браузеру вертикальний скрол сторінки:
  // вертикальний жест він забирає собі (pointercancel), горизонтальний
  // доходить до нас
  var SWIPE_MIN = 40; // px горизонтального зсуву, щоб зарахувати свайп
  var wrapper = container.closest('.integrations__items-wrapper') || container;
  wrapper.style.touchAction = 'pan-y';

  var swipe = null; // { id, x, y } активного жесту

  wrapper.addEventListener('pointerdown', function (e) {
    if (!mobileQuery.matches || e.pointerType === 'mouse') return;
    swipe = { id: e.pointerId, x: e.clientX, y: e.clientY };
  });

  wrapper.addEventListener('pointermove', function (e) {
    if (!swipe || e.pointerId !== swipe.id) return;
    var dx = e.clientX - swipe.x;
    var dy = e.clientY - swipe.y;
    if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy)) return;
    swipe = null;
    stopAutoplay();
    rotateTo((activeIndex + (dx < 0 ? 1 : -1) + n) % n);
  });

  function endSwipe(e) {
    if (swipe && e.pointerId === swipe.id) swipe = null;
  }
  wrapper.addEventListener('pointerup', endSwipe);
  wrapper.addEventListener('pointercancel', endSwipe);

  startAutoplay();

  items[activeIndex].classList.add('is-active');
  layout();

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (tl) tl.kill();
      C = conf();
      layout();
    }, 100);
  });
}

// маркіза інструментів: на мобілці айтеми діляться на два ряди, які
// нескінченно їдуть у протилежні боки; на десктопі ряди-обгортки мають
// display: contents і вебфлоушна wrap-розкладка лишається як була
function initToolsMarquee() {
  var container = document.querySelector('.tools__items');
  if (!container || typeof gsap === 'undefined') return;

  var items = Array.prototype.slice.call(container.querySelectorAll('.tools-item'));
  if (items.length < 2) return;

  var mq = window.matchMedia('(max-width: 479px)');
  var SPEED = 40; // px за секунду

  // два ряди, айтеми по черзі
  var rows = [document.createElement('div'), document.createElement('div')];
  rows.forEach(function (row) {
    row.className = 'tools__row';
    container.appendChild(row);
  });
  items.forEach(function (item, i) {
    rows[i % 2].appendChild(item);
  });

  var tweens = [];

  function clear() {
    tweens.forEach(function (t) {
      t.kill();
    });
    tweens = [];
    rows.forEach(function (row) {
      gsap.set(row, { clearProps: 'transform' });
      Array.prototype.forEach.call(row.querySelectorAll('.is-clone'), function (el) {
        el.remove();
      });
    });
  }

  function build() {
    clear();
    if (!mq.matches) return;

    rows.forEach(function (row, r) {
      var originals = Array.prototype.slice.call(row.children);
      var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      var period = row.offsetWidth + gap;
      if (!period) return;

      // копій вистачає, щоб перекрити екран плюс один період руху
      var copies = Math.ceil((window.innerWidth + period) / period);
      for (var i = 0; i < copies; i++) {
        originals.forEach(function (el) {
          var clone = el.cloneNode(true);
          clone.classList.add('is-clone');
          row.appendChild(clone);
        });
      }

      // парний ряд їде вліво, непарний — вправо
      var from = r % 2 ? -period : 0;
      var to = r % 2 ? 0 : -period;
      tweens.push(gsap.fromTo(row, { x: from }, {
        x: to,
        duration: period / SPEED,
        ease: 'none',
        repeat: -1
      }));
    });
  }

  // перебудова лише при зміні ширини (resize по висоті на мобілці кидає
  // скрол з адресною стрічкою) і після довантаження шрифтів
  var lastWidth = window.innerWidth;
  var resizeTimer;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(build, 200);
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(build);
  }
  build();
}

function initLogosMarquee() {
  var container = document.querySelector('.intro__logos');
  if (!container || typeof gsap === 'undefined') return;

  // айтем марквізу — обгортка .intro__visual з двома варіантами лого
  // всередині (моно + кольоровий для ховера)
  var logos = Array.prototype.slice.call(container.querySelectorAll('.intro__visual'));
  if (logos.length < 2) return;

  var SPEED = 60; // px per second
  var MIN_OPACITY = 0.5;
  var CENTER_ZONE = 1098; // px, зона повної видимості з дизайну
  var MAX_SETS = 20;

  // на тачі перший тап кидає mouseover без mouseout — стрічка ставала б
  // на паузу назавжди; ховер-логіка тільки для пристроїв з курсором
  var hasHover = window.matchMedia('(hover: hover)').matches;

  // лого на мобілці нижче фолду: якщо картинки ліниві, load не настане,
  // поки до них не доскролять, і build не запуститься — вантажимо одразу
  Array.prototype.forEach.call(container.querySelectorAll('img'), function (img) {
    img.loading = 'eager';
  });

  var track = document.createElement('div');
  track.className = 'intro__logos-track';

  logos.forEach(function (el) {
    track.appendChild(el);
  });
  container.appendChild(track);

  var setSize = logos.length;
  var tween = null;
  var step = 0; // відстань між сусідніми логотипами (центр-центр)

  function build() {
    if (tween) {
      tween.kill();
      tween = null;
    }
    gsap.set(track, { x: 0 });

    // лишаємо в треку тільки оригінальний сет — він уже завантажений,
    // тому всі виміри по ньому коректні
    while (track.children.length > setSize) {
      track.removeChild(track.lastChild);
    }

    var setWidth = track.offsetWidth;
    if (!setWidth) return;

    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    var period = setWidth + gap; // шлях одного повного циклу
    step = period / setSize;

    // скільки сетів треба, щоб перекрити контейнер + один період руху
    var setsNeeded = Math.max(2, Math.ceil((container.offsetWidth + period) / period));
    setsNeeded = Math.min(setsNeeded, MAX_SETS);

    var fragment = document.createDocumentFragment();
    for (var i = 1; i < setsNeeded; i++) {
      logos.forEach(function (el) {
        fragment.appendChild(el.cloneNode(true));
      });
    }
    track.appendChild(fragment);

    tween = gsap.to(track, {
      x: -period,
      duration: period / SPEED,
      ease: 'none',
      repeat: -1
    });
  }

  // центральна зона 1098px повністю видима, поза нею опасіті лінійно
  // спадає до 0.5 на краю контейнера (краї додатково накриває градієнт
  // у колір фону — див. _intro.sass). Якщо зона не влазить (мобілка,
  // планшет) — фейду немає зовсім: усі лого на 100%, як у дизайні
  gsap.ticker.add(function () {
    if (!step) return;
    var bounds = container.getBoundingClientRect();
    var fadeZone = (bounds.width - CENTER_ZONE) / 2;
    var items = track.children;
    var i;
    if (fadeZone <= 0) {
      // чистимо інлайн-опасіті, що могли лишитись після ресайзу з десктопа
      for (i = 0; i < items.length; i++) {
        if (items[i].style.opacity) items[i].style.opacity = '';
      }
      return;
    }
    for (i = 0; i < items.length; i++) {
      // логотип під курсором завжди повністю видимий, навіть біля краю
      if (hasHover && items[i].matches(':hover')) {
        items[i].style.opacity = 1;
        continue;
      }
      var r = items[i].getBoundingClientRect();
      var center = r.left + r.width / 2 - bounds.left;
      var distFromEdge = Math.min(center, bounds.width - center);
      var t = Math.max(0, Math.min(1, distFromEdge / fadeZone));
      items[i].style.opacity = (MIN_OPACITY + (1 - MIN_OPACITY) * t).toFixed(3);
    }
  });

  // ховер на лого зупиняє стрічку; масштаб і підміна на кольоровий
  // варіант — у CSS (.intro__visual:hover)
  if (hasHover) {
    track.addEventListener('mouseover', function (e) {
      if (tween && e.target.closest('.intro__visual')) tween.pause();
    });
    track.addEventListener('mouseout', function (e) {
      if (!tween) return;
      var to = e.relatedTarget;
      if (!to || !to.closest('.intro__visual')) tween.play();
    });
  }

  // build тільки після того, як самі картинки отримали розміри,
  // інакше period і кількість копій порахуються неправильно
  function whenImagesReady(cb) {
    var pending = Array.prototype.slice.call(track.querySelectorAll('img')).filter(function (img) {
      return !img.complete;
    });
    if (!pending.length) {
      cb();
      return;
    }
    var left = pending.length;
    var called = false;
    function fire() {
      if (called) return;
      called = true;
      cb();
    }
    pending.forEach(function (img) {
      function done() {
        left--;
        if (left === 0) fire();
      }
      img.addEventListener('load', done);
      img.addEventListener('error', done);
    });
    // якщо якась картинка так і не завантажилась (повільна мережа,
    // блокувальник) — стартуємо з тим, що є, ніж стояти без анімації
    setTimeout(fire, 3000);
  }

  // перебудова тільки при зміні ширини: на мобілці скрол ховає адресну
  // стрічку браузера і кидає resize по висоті — без цієї перевірки
  // анімація на кожен такий resize стартувала б з початку
  var lastWidth = window.innerWidth;
  var resizeTimer;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(build, 200);
  });

  whenImagesReady(build);
}
